export const festivaldetailsData = {
  
    'vinayakavratam': {
      "CatID": [
        {
          "title": "వినాయక వ్రత కథ చదివేవారు, పూజలో కూర్చునేవారు, కధని ఆలకించేవారు ముందు చేతిలో కొద్దిగా అక్షింతలు తీసుకోవాలి. కథ పూర్తయిన తర్వాత కొన్ని అక్షింతలు విఘ్నేశ్వరుని పాదముల దగ్గర ఉంచి మరికొన్ని అక్షింతలు తమ శిరస్సుపై ఉంచుకోవాలి."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">వినాయక వ్రత కథ ప్రారంభము :</span>
        },
        {
          "title": ""
        },
        {
          "title": "పూర్వం చంద్రవంశానికి చెందిన ధర్మరాజు దాయాదుల వల్ల రాజ్యాన్ని, సిరిసంపదలన్నీ పోగొట్టుకున్నాడు. భార్య, తమ్ములతో వనవాసం చేస్తూ ఒకనాడు నైమిశారణ్యానికి చేరుకున్నాడు. అక్కడ శౌనకాది ఋషులకు అనేక పురాణ రహస్యాలను బోధిస్తున్న సూతమహామునిని దర్శించి ఋషివర్యా, మేము రాజ్యాధికారాన్నీ సమస్త వస్తు వాహనాలనూ పోగొట్టుకున్నాము. ఈ కష్టాలన్నీ తీరి, పూర్వవైభవం పొందేలా ఏదైనా సులభమైన వ్రతాన్ని చెప్పండి అని ప్రార్థించాడు. అప్పుడు సూతమహాముని ధర్మరాజుకు వినాయకవ్రతం చేస్తే కష్టాలు తొలగిపోయి, సమస్త సౌఖ్యాలూ కలుగుతాయి అంటూ ఇలా చెప్పసాగాడు."
        },
        {
          "title": ""
        },
        {
          "title": "ఒకసారి కుమారస్వామి పరమశివుణ్ణి దర్శించి తండ్రీ! మానవులు ఏ వ్రతం చేయడం వలన వంశాభివృద్ధిని పొంది, సమస్త కోరికలూ తీరి, సకల శుభాలనూ, విజయాలనూ, వైభవాలనూ పొందగలుగుతారో అటువంటి వ్రతాన్ని చెప్పండి అని కోరాడు. అందుకు శివుడు ‘నాయనా! సర్వసంపత్కరం, ఉత్తమమైన వినాయక వ్రతము అనేది ఒకటుంది. దీన్ని భాద్రపద శుద్ధ చవితినాడు ఆచరించాలి."
        },
        {
          "title": ""
        },
        {
          "title": "ఆ పర్వదినము రోజున ఉదయాన్నే నిద్రలేచి ఇంటిని శుభ్రపరచుకొని, తలంటు స్నానం చేసి ఉతికిన వస్త్రాలు ధరించి మామిడి తోరణములతో ఇంటిని అలంకరించాలి. ఆ తర్వాత పాలవెల్లికి పసుపు రాసి, కుంకుమ బొట్టు పెట్టి దానిని పండ్లతో, మొక్కజొన్న పొత్తులతో గాని అలంకరించాలి."
        },
        {
          "title": ""
        },
        {
          "title": "పాలవెల్లికి మధ్యలో ఉండే విధంగా తమ శక్తిమేరకు బంగారంతోగానీ, వెండితోగానీ లేదా మట్టితోగానీ తయారు చేసిన వినాయకుని ప్రతిమను ప్రతిష్టించి స్వామివారిని గరిక (లేదా) 21 రకాల పత్రాలతోనూ పూజించి, వ్రతకధ చెప్పుకొని ఉండ్రాళ్ళు, మొదలైన పదార్ధాలను నైవేద్యంగా సమర్పించవలెను. నృత్య, గీత, వాద్య పురాణ పఠనాదులతో పూజను ముగించి, యథాశక్తి వేదవిదులైన బ్రాహ్మణులకి దక్షిణ, తాంబూలాదులు ఇవ్వాలి."
        },
        {
          "title": ""
        },
        {
          "title": "బంధుజనంతో కలిసి భక్ష్య భోజ్యాదులతో భోజనం చేయాలి. మరుసటిరోజు ఉదయం స్నానసంధ్యలు పూర్తిచేసుకుని గణపతికి పునఃపూజ చేయాలి. ఈ విధంగా ఎవరైతే వినాయక వ్రతాన్ని చేస్తారో వాళ్ళకి గణపతి ప్రసాదం వలన సకల కార్యాలూ సిద్ధిస్తాయి."
        },
        {
          "title": ""
        },
        {
          "title": "అన్ని వ్రతాల్లోకీ అత్యుత్తమమైన ఈ వ్రతం త్రిలోక ప్రసిద్ధమై దేవ, ముని, గంధర్వాదులందరిచేతా ఆచరింపబడింది అని పరమశివుడు కుమారస్వామికి చెప్పాడు."
        },
        {
          "title": ""
        },
        {
          "title": "కనుక ధర్మరాజా! నువ్వు కూడా ఈ వ్రతాన్ని ఆచరించినట్లయితే నీ శత్రువులను జయించి సమస్త సుఖాలనూ పొందుతావు. గతంలో విదర్భ యువరాణి దమయంతి ఈ వ్రతం చేయడం వల్లనే తాను ప్రేమించిన నలమహారాజును పెళ్లాడ గలిగింది. శ్రీకృష్ణుడంతటివాడు ఈ వ్రతం చేయడం వల్లనే శమంతకమణితోబాటుగా జాంబవతీ, సత్యభామలనే ఇద్దరు కన్యామణులను కూడా పొందగలిగాడు. ఆ కథ చెబుతాను విను అంటూ ఇలా చెప్పసాగాడు."
        },
        {
          "title": ""
        },
        {
          "title": "పూర్వం గజాసురుడు శివుడి కోసం తపస్సు చేశాడు. అతని తపస్సునకు మెచ్చి పరమేశ్వరుడు ప్రత్యక్షమై వరం కోరుకోమన్నాడు. గజాసురుడు స్వామీ నువ్వు నా ఉదరమందే నివసించాలి అని కోరాడు. దాంతో భక్తసులభుడైన శివుడు అతడి ఉదరమందే ఉండిపోయాడు. జగన్మాత పార్వతీదేవి భర్తను వెదుకుతూ ఆయన గజాసురుని గర్భములో ఉన్నాడని తెలిసి, ఆయన్ను దక్కించుకునే ఉపాయం కోసం శ్రీమహావిష్ణువును ప్రార్థించినది. శ్రీహరి బ్రహ్మాది దేవతలను పిలిపించి గజాసుర సంహారానికి గంగిరెద్దు మేళమే తగినదని నిర్ణయించి, నందీశ్వరుణ్ణి గంగిరెద్దుగా అలంకరించారు. బ్రహ్మాది దేవతలందరూ తలొక వాయిద్యాన్ని ధరించారు. మహావిష్ణువు చిరుగంటలు, సన్నాయిలు ధరించాడు. గజాసుర పురానికి వెళ్ళి గంగిరెద్దును ఆడిస్తుండగా గజాసురుడది విని, వారిని పిలిపించి తన భవనం ఎదుట గంగిరెద్దును ఆడించమని కోరాడు. బ్రహ్మాది దేవతలు వాద్యాలను వాయిస్తుండగా జగన్నాటక సూత్రధారియైన హరి చిత్రవిచిత్రంగా గంగిరెద్దును ఆడించాడు."
        },
        {
          "title": ""
        },
        {
          "title": "గజాసురుడు పరమానందభరితుడై ఏమి కావాలో కోరుకోమన్నాడు. అంతట శ్రీహరి గజాసురుణ్ణి సమీపించి ఇది శివుని వాహనమైన నంది, శివుణ్ణి కనుగొనడానికి వచ్చింది, శివుణ్ణి అప్పగించు’ అని కోరాడు. ఆ మాటలకు గజాసురుడు నివ్వెరపోయి, వచ్చినవాడు రాక్షసాంతకుడైన శ్రీహరి అని తెలుసుకొని, తనకు మరణమే నిశ్చయమనుకున్నాడు. తన గర్భంలో ఉన్న పరమేశ్వరుణ్ణి ఉద్దేశించి స్వామీ, నా శిరస్సును త్రిలోక పూజ్యముగా చేసి, నా చర్మాన్ని నువ్వు ధరించు అని ప్రార్థించాడు. తన గర్భంలో ఉన్న శివుణ్ణి తీసుకోవచ్చునని విష్ణుమూర్తికి అంగీకారం తెలియజేశాడు. అంత శ్రీహరి నందిని ప్రేరేపించగా, నంది తన కొమ్ములతో గజాసురుని ఉదరాన్ని చీల్చాడు. బ్రహ్మాది దేవతలకు వీడ్కోలు చెప్పి శ్రీహరి వైకుంఠానికి వెళ్ళగా, శివుడు నందినెక్కి కైలాసానికి వెళ్లాడు."
        },
        {
          "title": ""
        },
        {
          "title": "తన భక్తుడైన గజాసురుని కోరిక మేరకు అతడి ఉదరంలో ఉన్న పరమేశ్వరుని శ్రీమహావిష్ణువు విముక్తి కల్పించడంతో భర్త రాకకు పార్వతి కైలాసంలో ఎదురుచూస్తోంది. శివుడి కోసం ఎదురు చూస్తూ స్నానానికి సిద్ధమైంది. స్నానానికి వెళుతూ దేహానికి నలుగుపిండిని అద్దుకుంది. పరధ్యానంలో ఆ పిండితోనే ఓ ప్రతిమను తయారుచేసింది. చూడముచ్చటైన ఆ బాలుడికి తండ్రి ఉపదేశించిన మంత్ర సాయంతో పార్వతి ప్రాణం ప్రతిష్ఠ చేసింది."
        },
        {
          "title": ""
        },
        {
          "title": "సుందరమైన ఆ బాలుని వాకిట కాపలా ఉంచి తాను స్నానానికి వెళ్లింది. అంతలో అక్కడికి వచ్చిన శివుడిని ఆ బాలుడు అడ్డుకున్నాడు. ఆగ్రహావేశాలకు లోనైన రుద్రుడు ఆ బాలుడి శిరస్సును తన త్రిశూలంతో ఖండించాడు. ఆ శబ్దానికి బయటికి వచ్చిన పార్వతీ దేవి, జరిగిన ఘోరం చూసి కన్నీళ్లు పెట్టుకుంది. దీంతో శివుడు గజముఖుడి శిరస్సును తెప్పించి ఆ బాలుడికి అతికించి ప్రాణం పోసి గజాననుడు అనే నామకరణం చేశాడు. అతడి శక్తి సామర్ధ్యాలను పరిశీలించి భాద్రపద శుద్ధ చవితి నాడు గణాధిపత్యాన్ని ఇచ్చారు. ఆ రోజున తనకు భక్తితో సమర్పించిన ఉండ్రాళ్లు, కుడుములు, పిండివంటలు, పండ్లను సుష్టిగా తిన్న వినాయకుడి నడవటానికి ఇబ్బందిపడుతూ కైలాసం చేరుకున్నాడు."
        },
        {
          "title": ""
        },
        {
          "title": "శివుని శిరస్సుపై ఉన్న చంద్రుడు గణనాధుని అవస్థలు చూసి పక్కున నవ్వాడు. రాజ‌దృష్టి సోకితే రాళ్లు కూడా నుజ్జవుతాయని విఘ్ననాధుని ఉదరం పగిలి అందులోని ఉండ్రాళ్లు, కుడుములు బయటకు వచ్చి అచేతనుడయ్యాడు. దీంతో ఆగ్రహించిన పార్వతి దేవి, పాపాత్ముడా నీ దృష్టిసోకి నా కుమారుడు అచేతనంగా పడివున్నాడు కాన నిన్నుచూసివారు పాపాత్ములై నీలాపనిందలు పొందుదురు గాక అని శపించింది."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">ఋషి పత్నులకు నీలాపనిందలు :</span>
        },
        {
          "title": ""
        },
        {
          "title": "పార్వతీదేవి చంద్రుని శపించిన సమయంలో సప్తఋషులు భార్యలతో కలసి యజ్ఞం చేస్తూ, అగ్నిదేవునికి ప్రదక్షిణం చేస్తున్నారు. అగ్నిదేవుడికి ఋషిపత్నుల మీద మోహం కలిగింది. కోరిక తీరక, శపిస్తారేమో అనే భయంతో అగ్ని క్షీణింపసాగాడు. భర్త కోరిక తెలుసుకున్న స్వాహాదేవి ఋషుల భార్యల రూపంలో అగ్నిదేవుడిని చేరింది. అగ్నిదేవునితో ఉన్నది తమ భార్యలేనని భ్రాంతి చెందిన ఋషులు, వారిని విడిచిపెట్టారు. శాపగ్రస్థుడైన చంద్రుని చూడటం వల్లనే ఋషుల భార్యలు నీలాపనిందలకు గురయ్యారని దేవతలు గ్రహించారు. దేవతలందరూ బ్రహ్మదేవునితో కలసి కైలాసానికి వెళ్లారు. మరణించిన విఘ్నేశ్వరుడిని బ్రహ్మదేవుడు తిరిగి బతికించాడు."
        },
        {
          "title": ""
        },
        {
          "title": "తర్వాత పార్వ‌తీదేవితో అమ్మా నీవు చంద్రునికి ఇచ్చిన శాపం వలన ఆపద కలిగింది. కావున శాపాన్ని ఉపసంహరించుకో అని కోరాడు. అప్పుడు పార్వతీదేవి ఏ రోజున చంద్రుడు విఘ్నేశ్వరున్ని చూసి నవ్వాడో ఆ రోజు చంద్రుణ్ణి చూడకూడదు అని శాపాన్ని సవరించింది. ఆ రోజునుంచి అందరూ భాద్రపద శుద్ధ చవితి నాడు చంద్రుణ్ణి చూడకుండా జాగ్రత్తగా ఉండి, సుఖంగా ఉన్నారు. ఇలా కొంతకాలం గడిచింది."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">శమంతకోపాఖ్యానం :</span>
        },
        {
          "title": ""
        },
        {
          "title": "ద్వాపరయుగంలో ద్వారకలో నివాసం ఉన్న శ్రీకృష్ణుడిని నారదుడు కలిశాడు. కాసేపు  ముచ్చటించాక స్వామీ! ఈ రోజు వినాయక చవితి, పార్వతి శాపం కారణంగా చంద్రుని చూడరాదు అని కృష్ణుడికి చెప్పి నారదుడు వెళ్లిపోయాడు. ఆ రోజు రాత్రి ఎవ్వరూ చంద్రుణ్ణి చూడకూడదని పట్టణంలో శ్రీకృష్ణుడు చాటింపు వేయించాడు. శ్రీకృష్ణుడికి పాలంటే ఇష్టం కావున ఆ రోజు రాత్రి శ్రీకృష్ణుడు ఆవు పాలను తాగుతుండగా పాత్రలోని పాలలో చవితి చంద్రుడి ప్రతిబింబాన్ని చూశాడు. దాంతో తనకెలాంటి అపనింద రానుందో అని చింతించాడు. కొన్ని రోజులు గడిచాయి. సత్రాజిత్తు సూర్యుని వరంతో శమంతకమణిని సంపాదించాడు."
        },
        {
          "title": ""
        },
        {
          "title": "రోజుకు పది బారువుల బంగారాన్ని ఇచ్చే ఆ మణిని తీసుకుని ద్వారకకు వెళ్లాడు. శ్రీకృష్ణుడు సత్రాజిత్తుకు అతిథి మర్యాదలు చేసి ఆ మణిని తనకు ఇవ్వమని కోరాడు. అందుకు సత్రాజిత్తు ఒప్పుకోలేదు. తర్వాత ఒక రోజు సత్రాజిత్తు తమ్ముడు ప్రసేనుడు శమంతకమణిని మెడలో వేసుకుని అడవికి వేటకు వెళ్లాడు. అడవిలో ఒక సింహం ఆ మణిని చూసి మాంసం ముక్క అనుకొని ప్రసేనుణ్ణి చంపింది. మణిని నోట కరచుకుని పోతూన్న సింహాన్ని జాంబవంతుడు చంపి, శమంతకమణిని కొండగుహలో ఉన్న తన కూతురు జాంబవతికి ఆట వస్తువుగా ఇచ్చాడు."
        },
        {
          "title": ""
        },
        {
          "title": "మరుసటి రోజు సత్రాజిత్తు తమ్ముడి మరణవార్త విన్నాడు. శ్రీకృష్ణుడే తన తమ్ముడిని చంపి శమంతకమణిని అపహరించాడని నిందించాడు. శ్రీకృష్ణుడు అది విన్నాడు. భాద్రపద శుద్ధ చవితి రోజు చంద్రబింబాన్ని చూసిన దోషంవల్ల తన మీద నింద పడిందనుకున్నాడు. శమంతకమణిని వెదుకుతూ అడవికి వెళ్లాడు. ఒక చోట ప్రసేనుడి శవం కనిపించింది. అక్కడి నుంచి సింహం అడుగులు కనిపించాయి."
        },
        {
          "title": ""
        },
        {
          "title": "అలా వెదుకుతూ వెళ్లి ఒక పర్వత గుహలోకి ప్రవేశించాడు. అందులో ఉన్న ఉయ్యాలకు కట్టిన మణిని చూసి, దానిని తీసుకుని బయటకు రాసాగాడు. వెంటనే జాంబవతి పెద్దగా ఏడ్వసాగింది. కూతురి ఏడుపు విని జాంబవంతుడు కోపంతో శ్రీకృష్ణుడిపై యుద్ధానికి తలపడ్డాడు. వారిద్దరి మధ్య ఇరవై ఎనిమిది రోజులు యుద్ధం జరిగింది. జాంబవంతుని శక్తి క్షిణించింది. తనతో యుద్ధం చేస్తున్నవాడు శ్రీరామచంద్రుడని గ్రహించి, త్రేతాయుగంలో జాంబవంతుడు శ్రీరాముడితో యుద్ధం చేయాలని కోరాడు. ఆ కోరికను ఇప్పుడు శ్రీకృష్ణుని రూపంలో వచ్చి తీర్చాడని గ్రహించి, శ్రీకృష్ణుడికి నమస్కరించి శమంతకమణితో పాటు తన కుమార్తె జాంబవతిని కూడా ఆయనకు సమర్పించాడు. శ్రీకృష్ణుడు శమంతకమణిని తెచ్చి సత్రాజిత్తుకు ఇచ్చాడు. నిజం తెలుసుకున్న సత్రాజిత్తు తనను క్షమించమని శ్రీకృష్ణుడిని వేడుకున్నాడు. తన కుమార్తె సత్యభామను ఇచ్చి వివాహం జరిపించాడు. శమంతకమణిని కూడా శ్రీకృష్ణుడికి ఇచ్చాడు."
        },
        {
          "title": ""
        },
        {
          "title": "ఆ సమయంలో అక్కడకు వచ్చిన మునులు శ్రీకృష్ణుడితో మీరు సమర్థులు కనుక మీపై పడిన నిందను పోగొట్టుకోగలిగారు, మావంటి వారికి ఏది గతి అన్నారు."
        },
        {
          "title": ""
        },
        {
          "title": "భాద్రపద శుద్ధ చవితినాడు యథావిధిగా వినాయకుని పూజించి ఈ శమంత కోపాఖ్యానాన్ని విని అక్షతలు తలపై వేసుకున్న వారికి, ఆరోజు చంద్ర దర్శనం అయినా కూడా అపనిందలు కలగవు అని శ్రీకృష్ణుడు చెప్పాడు. ఆ నాటి నుంచి ప్రతి సంవత్సరం భాద్రపద శుద్ధ చవితి రోజు దేవతలు, మహర్షులు, మానవులు తమ శక్తికి తగినట్లుగా గణపతిని పూజించి తమ కోరికలు తీర్చుకుంటున్నారు.ఈ కథను చదివి గాని, విని గాని తలపై అక్షతలను వేసుకొని వినాయక వ్రతాన్ని ముగించాలి. చివరగా వినాయకుని ఎదుట వీలైనన్ని గుంజీలు తీసి, సాష్టాంగ నమస్కారాలు చేయాలి."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">సర్వేజనా సుఖినోభవంతు</span>
        },
      ],
      "title": "వినాయక కథ"
    },
    "mahasivaratri": {
      "CatID": [
        {
          "title": "భారతీయ తెలుగు సాంప్రదాయ పండగలన్నీ తిధులతోను,నక్షత్రాములతోను ముడిపడి ఉంటాయి.కొన్ని పండగలకు తిధులు,మరికొన్ని పండగలకు నక్షత్రాలు ప్రధానమవుతాయి. ఈ పద్ధతిలో ప్రతి నెల చాంద్రమాసము ప్రకారం కృష్ణ పక్షములోని ప్రదోష వ్యాప్తిగల చతుర్ధశి తిధిని మాసశివరాత్రి అంటారు.ఇది శైవులకు ఉపవాస వ్రతములకు ముఖ్యమైనదిగా భావించి శివున్ని కొలుస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "మాఘమాసములో కృష్ణ పక్ష చతుర్ధశి అర్ధరాత్రి వ్యాప్తి చెంది ఉన్నరోజును మహాశివరాత్రిగా పరిగణింపబడినదని శాస్త్ర వచనం. అమావాస్యకు ముందు వచ్చే కృష్ణ పక్ష చతుర్ధశినాడే శివరాత్రి జరుపుకోవాలని శాస్త్ర నిర్ణయము."
        },
        {
          "title": ""
        },
        {
          "title": "సంక్రాంతి పండగ తర్వాత వచ్చే పండగలలో ముఖ్యమైనది మహాశివరాత్రి.అన్ని పండగలు పగటి పూట జరుపుకుంటే ఈ పండగ మాత్రం రాత్రిపూట జరుపుకుంటాము.మహాశివరాత్రి రోజున అర్ధరాత్రి 12 గంటలకు జ్యోతి స్వరూపుడైన శివుడు లింగ రూపంలో దర్శనమిచ్చే పవిత్ర పర్వదినము. శివరాత్రి రోజు పగలంతా ఉపవాసం ఉండి రాత్రి సమయంలో శివుడి అనుగ్రహం కొరకు నిదర పోకుండా జాగరణతో మేలుకొని భక్తిశ్రద్ధలతో అభిషేకాలు,పూజలు,భజనలు చేస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "ఇది హిందువులకు అత్యంత పుణ్య ప్రదమైన రోజు.మహశివరాత్రిని హిందువులు ఏంతో గొప్ప పర్వదినంగా జరుపుకొని శివున్ని కొలిచి తరిస్తారు. మహాశివరాత్రి రోజు ముఖ్యంగా పాటించవలసిన నియమాలు."
        },
        {
          "title": ""
        },
        {
          "title": "1) ఉపవాసం ఉండటం 2) రాత్రి జాగరణ చేయడం 3) శివనామ స్మరణతో అభిషేకాలు చేయడం."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">శివుడు లింగోద్భవ మూర్తిగా అవతరించడానికి గల కారణము:</span>
        },
        {
          "title": ""
        },
        {
          "title": "శివుడు లింగోద్భవ మూర్తిగా అవతరించడానికి ఒక పురాణ కధ ఉంది.ఒకానోక రోజు బ్రహ్మ,విష్ణువుల మధ్య మాట మాట పెరిగి వారీరువురిలో ఎవరు గొప్ప అని తేల్చుకోవలనుకున్నారు.ఈ విషయంలో వాదన తారాస్థాయికి చేరింది."
        },
        {
          "title": ""
        },
        {
          "title": "ఇద్దరిలో ఎవరూ తగ్గలేదు. ఇదంతా చూస్తున్న శివుడు వారికి తన శక్తిని చూపించాలని మాఘ మాస చతుర్ధశి తిధి రోజు ఇద్దరికీ మధ్య జ్యోతిర్లింగ రూపం దాల్చాడు. బ్రహ్మ,విష్ణువులు లింగాకారంలో ఉన్న ఆశివుని యొక్క ఆది,అంతం తెలుసుకోవలని విష్ణువు వరాహ రూపం ధరించి లింగాకారంలో ఉన్న శివలింగ అడుగు భాగాన్ని వెతుకుతూ వెళ్ళాడు.మరోవైపు బ్రహ్మ తన హంస వాహనమెక్కి ఆకాశమంతా తిరగడం ప్రారంభించాడు."
        },
        {
          "title": ""
        },
        {
          "title": "వీరిద్దరూ ఎంత ప్రయత్నించినా ఆ లింగం యొక్క మొదలు,చివర ఎదో అని తెలియక వెతుకుతూ అలసిపోయారు.చివరికి ఇక లాభం లేదనుకుని ఇద్దరు కలసి శివుని వద్దకు చేరుకొని మేము నీ శక్తిని తేల్చుకోలేకపోతున్నాము అని అడగగానే శివుడు చిరునవ్వు నవ్వి మీలో ఎవరు గొప్ప అనే పోటీతో వాదోప వాదనతో ఉన్నదానిని గమనించి మీ పోటీని తగ్గించడానికి నేను ఈ లింగాకారంగా అవతరించాల్సి వచ్చింది అని వారికి నిజరూపంతో వివరించి చెబుతాడు.అపుడు బ్రహ్మ విష్ణువులు శివుడి ఆధిక్యతను గ్రహించి పూజించి కీర్తిస్తారు.ఆ రోజే మహాశివరాత్రి అయినదని పురాణ కధనం."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">శివరాత్రి నాడు చేయవలసిన శాస్త్రవిధులు :-</span>
        },
        {
          "title": ""
        },
        {
          "title": "మహా శివరాత్రి రోజు భ్రాహ్మీ మూహూర్తంలో నిద్రలేచి ఇల్లాంత శుభ్రపరచుకుని శుచిగా తలస్నానం చేసి పూజా గదిని శుభ్రం చేసుకోవాలి.గుమ్మాలకు తోరణాలు కట్టుకోవాలి.పూజగదిలో ముగ్గులు వేసుకుని రకరకాల పూలతో అలంకరించుకోవాలి. లింగకారంలో ఉన్న శివునికి శుద్ధ జలంతో,ఆవుపాలతో,పంచామృతంతో వివిధ పూజా ద్రవ్యాలతో,పుష్పాలతో అభిషేకించుకుని ముఖ్యంగా మారేడు దళాలను,బిల్వపత్రాలను,తుమ్మిపూలను,గోగుపూలు,తెల్లని,పచ్చని పూలతో శివనామాలను కాని పంచాక్షరీ మంత్రమైన ఓం నమశ్శివాయ అని స్మరిస్తూ పూజించాలి."
        },
        {
          "title": ""
        },
        {
          "title": "తాంబూలం, అరటి పండు,జామపండు,ఖర్జూరపండును సమర్పించి పూజ చేస్తున్న సమయంలో నిష్టతో శివ అష్టోత్తరం/పంచాక్షరీ మంత్రాన్ని పఠించాలి.ప్రాత:కాలం నుండి ఉదయం 9 గంటల లోపు అభిషేకాలు చేసే పూజకు ఉత్తమ ఫలితాలు ఉంటాయి. మననం చేసేవారిని కాపాడేది మంత్రం అంటారు కాబట్టి పరమేశ్వరుణ్ణి మనస్సులో నిరంతరం మననం చేసుకోవడం వలన అష్టైశ్వర్యాలు,సుఖ సంతోషాలు, భోగభాగ్యాలు కలుగుతాయి.శివరాత్రి రోజు అర్ధరాత్రి 12 గంటలకు లింగోద్భవ సమయం. ఈ సమయంలో కనుక శివున్నిఅభిషేకిస్తే పునర్జన్మ ఉండదని ప్రతీతి. శివుడు అభిషేక ప్రియుడు.స్వామికి భక్తితో నీళ్ళతో అభిషేకం చేసిన చాలు తమ భక్తుల భక్తికి స్వామి పొంగిపోతాడు అందుకే శివున్ని బోళాశంకరుడని పేరు."
        },
        {
          "title": ""
        },
        {
          "title": "సాయంత్రం 6 గంటల నుండి మరుసటి రోజు ఉదయం 6 గంటల వరకు భక్తి శ్రద్ధలతో శివ నామాలను,శివపురాణం మొదలగునవి చదువుకుంటే విశేష శుభఫలితాలు పొందుతారు. మహాశివుడు అనేవాడు మాతృవాత్సల్యం కలవాడు అంటే తల్లి తన బిడ్డను ఏ విధంగా రక్షించు కుంటుందో శివుడు తన భక్తుల భక్తికి పరవశించి కోరిన కోర్కెలను తీరుస్తూ రక్షించుకుంటాడు.ఈ మహా శివరాత్రికి పగలంతా ఉపవాసం ఉండి రాత్రంత జాగరణ చేసి మరుసటి రోజు స్నానం చేసి మహానైవేద్యంగా అన్నం కూరలు వండి దేవునికి నివేదన చూపించి ఉపవాస దీక్ష విరమణగావించాలి. ఈ పద్దతులలో చేస్తే ఎంతో పుణ్యప్రదంతో పాటు సమస్త గ్రహదోష నివారణ కలిగి దైవానుగ్రహం పొందుతారు."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">శివుని గొప్పతనాన్ని తెలిపిన ఋగ్వేదం :</span>
        },
        {
          "title": ""
        },
        {
          "title": "వేదాలు, ఇతిహాసాలు, పురాణాలలో ముఖ్యమైనవి. వీటిలో ఋగ్వేదం చాలా గొప్పది. ఇందులోని రుద్రం ఇంకా గొప్పది. పంచాక్షరీలోని శివ అనే రెండక్షరాలు మరీ గొప్పవి. శివ అంటే మంగళకరమని అర్థం. శివస్వరూపం అత్యంత మంగళకరమైనది. ఆ పరమ శివుని అనుగ్రహం కోసం జరుపుకునే ముఖ్యమైన పండుగ మహా శివరాత్రి. పురాణాలలో తెలియజేసిన మహా శివరాత్రిని ఏటా మాఘమాసం కృష్ణపక్ష చతుర్థశినాడు జరుపుకుంటాం."
        },
        {
          "title": ""
        },
        {
          "title": "మహాశివరాత్రి శ్రీ శైలంలో ఏ రోజు నిర్వహిస్తారో ఆరోజే ప్రజలందరు మహాశివరాత్రి ఉత్సవాలు జరుపుకోవడం అనేది తరతరాలుగ వస్తున్న సాంప్రదాయం కాబట్టి ఇది గమనించి వ్యవహరించుకోవడం ఉత్తమం."
        }
      ],
      "title": "మహాశివరాత్రి"
    },
    "christmas":{
      "CatID": [
  
        {
          "title": "లోకరక్షకుడు క్రీస్తు జన్మదినమే క్రిస్మస్‌.జీసస్ జన్మించి నేటికి రెండు వేల ఏళ్లు దాటినా కరుణామయుడుగానూ, దయామయుడుగానూ క్రెస్తవులతో ఆరాధనలను అందుకుంటున్నాడు. ఏసుక్రీస్తు పుట్టిన రోజునే ప్రపంచ వ్యాప్తంగా క్రిస్మస్ పండుగను ఎంతో పవిత్రంగా జరుపుకుంటారు. జీసస్ జన్మించి నేటికి రెండు వేల ఏళ్లు దాటినా కరుణామయుడుగానూ, దయామయుడుగానూ క్రెస్తవులతో ఆరాధనలను అందుకుంటున్నాడు."
        },
        {
          "title": ""
        },
        {
          "title": "రెండు వేల ఏళ్ల కిందట రోమ్ సామ్రాజ్యాన్ని పాలించే ఆగస్టస్ సీజర్ తన రాజ్యంలో ఎంత మంది జనాభా ఉన్నారో లెక్కించాడు. సులభంగా ఈ లెక్కలు సేకరించడానికి వీలుగా ప్రజలందరూ ఎవరి స్వగ్రామాలకు వాళ్లు డిసెంబరు 25 తేదీలోగా చేరుకోవాలని ఆజ్ఞాపించాడు. అదే సమయంలో రోమన్ సామ్రాజ్యంలోని నజరేతు పట్టణంలో ఉండే మేరీతో జోసెఫ్‌కు పెళ్లి కుదిరింది. ఒక రోజున మేరీకి గాబ్రియేల్ అనే దేవదూత కలలో కనబడి ‘ఓ మేరీ! నీవు దైవానుగ్రహం పొందావు. కన్యగానే గర్భం దాల్చి ఓ కుమారునికి జన్మనిస్తావు. అంతే కాదు పుట్టే బిడ్డకు ఏసు అని పేరు పెట్టాలని, అతడు దేవుని కుమారుడు అని తెలియజేసింది. ఏసు అంటే రక్షకుడు అని అర్థం."
        },
        {
          "title": ""
        },
        {
          "title": "దేవదూత చెప్పిన విధంగానే మేరీ గర్భం దాల్చింది. ఈ విషయం తెలిసిన జోసెఫ్ ఆమెను వివాహం చేసుకోరాదని నిర్ణయించుకున్నాడు. అయితే ఒక రోజు రాత్రి కలలో అతనికి దేవదూత కనపడి మేరీని నీవు విడిచిపెట్టవద్దు. ఆమె భగవంతుని వరంతో గర్భవతి అయింది. కాబట్టి ఆమెకు పుట్టే కొడుకు దేవుని కుమారుడు. తనను నమ్మిన ప్రజలందరిని వాళ్ల పాపాల నుంచి రక్షిస్తాడు అని పలికింది. జోసెఫ్ దైవాజ్ఞను అనుసరించి మేరీని ప్రేమతో ఆదరించాడు. ఇక రాజాజ్ఞ ప్రకారం జోసెఫ్, మేరీలు తమ స్వగ్రామమైన బెత్లేహామ్‌కు బయలుదేరారు. అయితే వారు అక్కడకు చేరుకునేసరికి ఉండటానికి వసతి దొరకలేదు. చివరకు ఒక సత్రం యజమాని తన పశువుల పాకలో వారికి ఆశ్రయం కల్పించాడు. అక్కడే ఏసుకు మేరీ జన్మనిచ్చింది. ఆ రాత్రి ఆ ఊరికి పక్క పొలాల్లో కొంతమంది తమ గొర్రెల మందలకు కాపలా కాస్తున్నారు. ఆ సమయంలో ఆకాశం నుంచి ఒక దేవదూత వారి ముందుకు దిగి వచ్చాడు. ఆ దూత చుట్టూ వెలుగులు ప్రసరించడంతో గొర్రెల కాపర్లు భయపడ్డారు. మీరు భయపడకండి, ఒక సంతోషకరమైన శుభవార్తను తెలియజేయడానికి ఇక్కడకు వచ్చాను. ఈ రోజు బెత్లెహోమ్‌లోని ఓ పశువుల పాకలో లోక రక్షకుడు పుట్టాడు, ఆయనే మీ అందరికీ ప్రభువు. ఒక పసికందు గుడ్డల్లో చుట్టి, పశువుల తొట్టిలో అమ్మ పొత్తిల్లలో పడుకుని ఉంటాడని, ఇవే మీకు ఆనవాళ్లని, అతడే లోకరక్షకుడు అని చెప్పాడు. గొర్రెల కాపర్లతో ఈ విషయం గురించి చెబుతుండగానే ఆ ప్రాంతమంతా ఆకాశం నుంచి దిగివచ్చిన దేవదూతలతో నిండిపోయింది."
        },
        {
          "title": ""
        },
        {
          "title": "అలా అక్కడకు వచ్చిన దేవదూతలు దేవున్ని స్తుతిస్తూ గీతాలు పాడి మాయమయ్యారు. గొర్రెల కాపరులు హుటాహుటిన దేవదూత చెప్పిన పశువుల పాకను చేరుకున్నారు. అక్కడ పశువుల తొట్టిలో పడుకొని ఉన్న శిశువుతోపాటు మేరీ, జోసెఫ్‌లను చూశారు. దేవదూత తమకు చెప్పిన విషయాన్ని వారు అందరికి తెలియజేశారు. అలా రెండు వేల సంవత్సరాల కిందట డిసెంబరు 24 న అర్థరాత్రి 12 తర్వాత జీసస్ జన్మించాడు. అంటే డిసెంబరు 25న జన్మించడంతో ఆ రోజునే క్రిస్మస్ జరుపుకుంటారు. క్రిస్మస్‌కు చాలా రోజుల ముందే పండుగ సందడి మొదలవుతుంది. దీనికోసం క్రైస్తవులు తమ ఇళ్లను, చర్చ్‌లను అందంగా అలంకరిస్తారు. వెదురు బద్దలు, రంగుల కాగితాలతో ఒక పెద్ద నక్షత్రాన్ని తయారుచేసి ఇంటిపై వేలాడ దీస్తారు. అలాగే తమ ఇంట్లో క్రిస్‌మస్‌ ట్రీ ఏర్పాటు చేస్తారు. దీన్ని రంగు రంగుల కాగితాలు, నక్షత్రాలు, చిరుగంటలు, చిన్న చిన్న గాజు గోళాలతోను అలంకరిస్తారు. ఇది ఈ పండుగ ప్రత్యేకత."
        },
        {
          "title": ""
        },
        {
          "title": "క్రిస్మస్ ముందు రోజు రాత్రి శాంతా క్లాజ్ పిల్లలకు బహుమతులు ఇచ్చి వెళ్తాడని నమ్ముతారు. అందుకోసం పిల్లలు తమ మేజోళ్లను వేలాడదీసి ఉంచుతారు. ఇలా ఉంచితే శాంతా క్లాజ్ వాటిలో బహుమతులను వేసి వెళ్తాడని నమ్మకం. క్రిస్‌మస్ రోజున బంధు మిత్రుల ఇళ్ళకు వెళ్లి శుభాకాంక్షలు తెలుపుతారు. క్రిస్‌మస్‌ ఏడాదికి ఒకసారి మాత్రమే వస్తుంది, కాబట్టి వచ్చేటప్పుడు ప్రేమాభిమానాలను సుఖసంతోషాలను తెస్తుందని నమ్ముతారు."
        }
      ],
      "title": "క్రిస్మస్"
    },
    "sankranthi": {
      "CatID": [
        {
          "title": "తెలుగు ప్రజలు జరుపుకొనే అతిపెద్ద పండుగ సంక్రాంతి. ఈ పండుగను నాలుగు రోజులపాటు ఘనంగా జరుపుకొంటారు. సూర్యుడు మకర రాశిలోకి ప్రవేశించిన రోజునే మకర సంక్రాంతి పండుగ జరుపుకుంటారు. గొబ్బెమ్మలు, భోగి మంటలు, గంగిరెద్దులు, పిండి వంటలు, హరిదాసు కీర్తనలు, రథం ముగ్గులు, కోడి పందాలు ఇలా సంకాంత్రి వచ్చిందంటే ఆ సందడే వేరు."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ పండుగను నాలుగు రోజులు జరుపుకుంటారు. ఈ పండుగ తొలి రోజును 'భోగి'గాను, రెండో రోజును 'మకర సంక్రాంతి'గాను, మూడో రోజును 'కనుమ'గాను పిలుస్తారు. నాలుగో రోజును 'ముక్కనుమ' గాను పిలుస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">మొదటి రోజు ( భోగి ) :</span>
        },
        {
          "title": ""
        },
        {
          "title": "సంక్రాంతికి ఒక రోజు ముందు భోగి పండుగతో సంబరాలు మొదలవుతాయి. భోగి అంటే భోగ భాగ్యాలను అనుభవించే రోజు అని అర్ధం. పాడి పంటలు సమృద్ధిగా ఇండ్లకు వచ్చే సమయం. ఈ రోజు సూర్యోదయానికి పూర్వమే నిద్రలేచి అభ్యంగన స్నానానంతరం ప్రతి ఇంటి ముందు భోగి మంటలు వేసుకొని పాతకు స్వస్తి చెప్పి నూతనత్వానికి స్వాగతం పలుకుతూ భోగి మంటలలో పాత పనికిరాని బట్టలను, వస్తువులను వేసి పీడలను,అరిష్టాలను తొలగించుకుంటారు. తెల్లవారక ముందే భోగి మంటలతో మొదలుకుని కుటుంబంలో ఆనంద కోలాహలం ప్రారంభం అవుతుంది. మనలో ఉన్న బద్దకాన్ని, అశ్రద్ధను, మనసులో ఉన్న చెడు తలంపులను ఈ భోగి మంటలలో వేసి ఈ రోజు నుండి నూతన ఆనంద, ఆప్యాయతలతో కూడుకొని ఉన్న జీవితాన్ని ప్రారంభిస్తున్నామని ఆత్మారామునికి మాట ఇచ్చి భవగత్ సన్నిదిలో నిశ్చయ సంకల్పం చేసుకోవడం జరుగుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "భోగి రోజున బొమ్మల కొలువు, పేరంటము కూడా చేస్తారు. ముఖ్యంగా భోగి పండుగ రోజు పెద్దలు తమ ఇంట్లోని చిన్నారుల తలపై రేగిపళ్లు పోస్తారు. భోగిపండ్ల కోసం రేగుపండ్లు, చెరుకుగడలు, బంతిపూల రేకులు, చిల్లర నాణేలు వాడతారు. కొందరు శనగలు కూడా కలుపుతారు. భోగిపండ్లను పిల్లల తల మీద పోయడం వలన శ్రీమన్నారాయణుడి దివ్య ఆశీస్సులు లభిస్తాయని భావిస్తారు. భోగి పండ్లు పోయడం వలన పిల్లల మీద ఉన్న చెడు దృష్టి తొలగిపోతుంది. తలపై భాగంలో బ్రహ్మరంధ్రం ఉంటుంది. భోగి పండ్లను పోసి దాని ప్రేరేపితం చేస్తే, పిల్లల్లో జ్ఞానం పెరుగుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "రేగి పండ్లను బదరీఫలం అని కూడా పిలుస్తారు. పురాణ కధనము ప్రకారం శివుణ్ని ప్రసన్నము చేసుకోవడానికి నరనారాయణులు బదరికావనంలో ఘోర తపస్సు చేశారట. ఆ సమయంలో దేవతలు వారి తలల మీద బదరీ ఫలాలని కురిపించారని చెబుతారు. ఆనాటి సంఘటనకు ప్రతీకగా పిల్లలను నారాయణుడిగా భావించి భోగిపండ్లను పోసే సంప్రదాయం వచ్చిందని ప్రతీతి."
        },
        {
          "title": ""
        },
        {
          "title": "భోగి ముగిశాక సూర్యుడు దక్షిణాయణం నుంచి ఉత్తరాయణానికి మరలుతాడు. ఆ రోజే మకర రాశిలోకి అడుగుపెడతాడు. సంక్రాంతి సూర్యుడి పండుగ కాబట్టి సూర్యుణ్ని పోలిన గుండ్రని రూపం, ఎర్రటి రంగు కారణంగా దీనికి అర్కఫలం అనే పేరు వచ్చింది. సూర్యభగవానుడి ఆశీస్సులు పిల్లవాడికి లభించాలనే సూచనగా ఈ భోగిపండ్లను పోస్తారు. కౌమర్యంలోకి అడుగు పెట్టడానికి ముందే అంటే 12 ఏళ్లలోపు చిన్నారుల తలపై భోగి పండ్లను పోయవచ్చు."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">రెండవ రోజు ( మకర సంక్రాంతి ) :</span>
        },
        {
          "title": ""
        },
        {
          "title": "సంక్రాంతి అంటే కొత్త వెలుగులు. ముఖ్యంగా సంక్రాంతి రోజున గాలిపటాల వేడుక నిర్వహించడం అనేది సాంప్రదాయము. ఈ పండుగను పూర్వం మన పెద్దలు దాదాపు 33 రోజలపాటు ఘనంగా జరుపుకునేవారు.కానీ మారుతున్న కాలానికి అనుగుణంగా ప్రస్తుతం ఈ పండుగను 4 రోజులపాటు మాత్రమే నిర్వహించుకుంటున్నారు. అయితే భగీరథుడు గంగను భూలోకానికి తీసుకువచ్చి సాగరులకు శాప విమోచనం చేయించింది ఈ రోజే అని శాస్త్రాలు చెబుతున్నాయి. ఇక సంక్రాంతికి నెల రోజుల ముందు నుండే పండుగ వాతావరణం కనిపిస్తుంది. మకర సంక్రమణం అంటే పాత పోయి కొత్తదనానికి స్వాగతం పలికే రోజు అని అర్థం. ఈ పర్వదినాలలో విష్ణు మూర్తిని ఆరాధిస్తాం."
        },
        {
          "title": ""
        },
        {
          "title": "సంక్రాంతి పండుగకు పంట కోతలు అయిపోయి ధాన్యం ఇంటికి వస్తుంది. దీంతో పొలాల్లో ఉండే కీటకాలు ఇంట్లోకి రాకుండా వాకిళ్ళలో కళ్లాపి చల్లి, ముగ్గులు వేసి అందులో రకరకాల రంగులను నింపి వాటి మధ్యలో ఆవు పేడతో చేసిన గొబ్బెమ్మలను పెడతారు. శ్రీమన్నారాయణుడి ప్రత్యక్షరూపం సూర్యభగవానుడు. సంక్రాంతి పర్వదినం రోజున ఉదయాన్నే లేచి తలస్నానం చేసి కొత్త దుస్తులను ధరించి, సూర్యభగవానుడిని ఆరాధించాలి. ఆ తర్వాత ఆదిత్యహృదయం, సూర్యాష్టకం పారాయణం చేయాలి. ఇక ఇంట్లో ఉండే పెద్దవాళ్ళ ఆశీర్వాదం తీసుకోవాలి."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ పండుగ రోజున గడపకు పసుపు రాసి, కుంకుమ పెట్టి, వాకిట్లో ముగ్గులు వేసి వాటిలో ఆవు పేడ గొబ్బెమ్మలు పెట్టడం, ఇంట్లో పిండివంటలు, పరమాన్నం చేసి శ్రీమన్నారాయణుడిని ఆరాధించడం వలన అన్ని శుభాలు జరుగుతాయని శాస్త్రాలు చెబుతున్నాయి.ఈ రోజు గాలి పటాలను ఎగుర వేయటం, ఆడవారు ముగ్గులు వేయటం, ముగ్గుల పోటీలు జరుపుకోవటం చేస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "అయ్యప్ప దీక్ష చేసేవారు 40 రోజుల తరువాత అయ్యప్పను, మకర జ్యోతిని కూడా ఈ రోజే దర్శించుకుంటారు."
        },
        {
          "title": ""
        },
        {
          "title": <span className="highlight">మూడవ రోజు ( కనుమ ) :</span>
        },
        {
          "title": ""
        },
        {
          "title": "ఈ కనుమ రోజున పశువులను లక్ష్మి స్వరూపాలుగా భావించి, అందంగా అలంకరించి పూజిస్తారు. ఇలా చేయటం వలన ఇంట్లో సంపదలు వృద్ధి చెందుతాయని నమ్మకం. ఎద్దుల పందాలు, కోడి పందాలు కూడా ఈ రోజున నిర్వహిస్తారు. సంక్రాంతిని సాగనంపడానికి ఈ రోజున రథం ముగ్గులు కూడా వేస్తారు. ఈ రోజుతో సంక్రాంతి ముగుస్తుంది."
        },
        {
          "title": ""
        },
        {
          "title": "కొన్ని ప్రాంతాలలోని ప్రజలు నాలుగో రోజు 'ముక్కనుమను' కూడా జరుపుకుంటారు."
        }
      ],
      "title": "సంక్రాంతి"
    },
    "varalakshmivratham": {
      "CatID": [
        // {
        //   "title":
        //     '@వరలక్ష్మీ వ్రతం',
        // },
        // {
        //   "title": '',
        // },
        {
          "title": 'శ్రావణమాసం శుక్లపక్షంలో పౌర్ణమికి ముందు వచ్చే శుక్రవారాన్ని వరలక్ష్మీ వ్రతాన్నిఆచరించాలి. ఆ రోజున వీలుకాకపోతే తరువాత వచ్చే శుక్రవారాలలో కూడా ఈ వ్రతాన్ని చేయకోవచ్చు. ఈ పండగను ముఖ్యంగా వివాహమైన మహిళలు నిర్వహిస్తారు.',
        },
        {
          "title": '',
        },
        {
          "title": '@వరలక్ష్మీ వ్రతం చేయ్యడానికి గల కారణము :',
        },
        {
          "title": '',
        },
        {
          "title": 'అష్టలక్ష్ముల్లో వరలక్ష్మీదేవికి ఓ ప్రత్యేకత ఉందంటారు. మిగిలిన లక్ష్మీ పూజలకంటే వరలక్ష్మీ పూజ శ్రేష్ఠమని శాస్త్ర వచనం. శ్రీహరి జన్మనక్షత్రమైన శ్రవణ నక్షత్రం పేరిట వచ్చే శ్రావణ మాసంలో ఈ వ్రతాన్ని చేస్తే విశేష ఫలితాలు లభిస్తాయంటారు. సర్వమంగళ సంప్రాప్తి కోసం, సకలాభీష్టాలకోసం, నిత్య సుమంగళిగా తాము వర్ధిల్లాలని పుణ్యస్త్రీలు ఈ వ్రతం చేస్తారు. దక్షిణ భారతదేశంలో ఈ వరలక్ష్మీ వ్రతాన్ని వివిధ సంప్రదాయాల్లో ఆచరిస్తారు. ఎవరు ఏ పద్ధతులు పాటించినా శ్రీ లక్ష్మిని కొలిచే తీరు మాత్రం అందరిదీ ఒక్కటే. సకల శుభంకరమైన, సన్మంగళదాయకమైన వరలక్ష్మీదేవి పూజ జగదానందకరమైనదని భక్తులందరి ప్రగాఢ విశ్వాసం.',
        },
        {
          "title": '',
        },
        {
          "title": '@పురాణ గాథ:',
        },
        {
          "title": '',
        },
        {
          "title": 'స్కాంద పురాణంలో పరమేశ్వరుడు వరలక్ష్మీ వ్రతం గురించి పార్వతీదేవికి వివరించిన వైనం ఉంది. లోకంలో స్త్రీలు సకల ఐశ్వర్యాలనూ, పుత్రపౌత్రాదులనూ పొందేందుకు వీలుగా ఏదైనా ఓక వ్రతాన్ని సూచించమని పార్వతీదేవి ఆది దేవుణ్ని కోరుతుంది. అప్పుడు శంకరుడు, గిరిజకు వరలక్ష్మీ వ్రత మహాత్మ్యాన్ని వివరించాడని చెబుతారు. అదే సందర్భంలో శివుడు ఆమెకు చారుమతీదేవి వృత్తాంతాన్ని తెలియజేశాడంటారు. భర్త పట్ల ఆదరాన్నీ, అత్తమామల పట్ల గౌరవాన్నీ ప్రకటిస్తూ చారుమతి ఉత్తమ ఇల్లాలుగా తన బాధ్యతల్ని నిర్వహిస్తూ ఉండేది. మహాలక్ష్మీదేవి పట్ల ఎంతో భక్తిశ్రద్ధలు కలిగిన చారుమతి, అమ్మవార్ని త్రికరణ శుద్ధిగా పూజిస్తుండేది. ఆ మహా పతివ్రత పట్ల వరలక్ష్మీదేవికి అనుగ్రహం కలిగి, స్వప్నంలో ఆమెకు సాక్షాత్కరిస్తుంది. శ్రావణ శుక్ల పూర్ణిమకు ముందు వచ్చే శుక్రవారాన తనను ఆరాధిస్తే కోరిన వరాలన్నీ ఇస్తానని ఆమెకు దేవదేవి అభయమిస్తుంది. అమ్మ ఆదేశానుసారం వరలక్ష్మీ వ్రతాన్ని ఆచరించి చారుమతి సమస్త సిరి సంపదల్ని అందుకుందని ఈశ్వరుడు, గౌరికి విశదపరచాడని పురాణ కథనం. దాంతో పార్వతీ దేవి కూడా ఈ వ్రతాన్ని ఆచరించి, వరలక్ష్మి కృపకు పాత్రురాలైందని చెబుతారు.',
        },
        {
          "title": '',
        },
        {
          "title": 'వరలక్ష్మీ వ్రతాన్ని ఆచరించే రోజున ఉదయాన్నే లేచి తలస్నానం చేసి ఇంటిని శుభ్రం చేసుకోవాలి. ఇంట్లోని పూజా మందిరంలో ఒక మండపాన్ని ఏర్పాటు చేసుకోవాలి. ఈ మండపంపై బియ్యపు పిండితో ముగ్గువేసి కలశం ఏర్పాటుచేసుకోవాలి. అమ్మవారి ఫొటో అమర్చుకోవాలి. పూజాసామగ్రిని అంతా సిద్ధం చేసుకోవాలి. తోరణాలు ముందుగానే సిద్ధం చేసుకుని ఉంచాలి. అక్షతలు, పసుపు గణపతిని సిద్ధంగా ఉంచుకోవాలి.',
        },
        {
          "title": '',
        },
        {
          "title": '@వ్రత విధి విధానం :',
        },
        {
          "title": '',
        },
        {
          "title": 'తొలుత పసుపుతో గణపతిని చేసి పూజించి, కలశం లోనికి వరలక్ష్మీ దేవిని ఆవాహన చేసి, షోడశోపచార పూజ, తరువాత అథాంగ పూజచేయవలెను. దాని తరువాత అష్టోత్తరశతనామ పూజతో నామాలను చదివి, దూప, దీప, నైవేద్యాలను తాంబూలాలని సమర్పించి, కర్పూర నీరాజనం, మంత్రపుష్పం సమర్పించి, మంగళహారతి ఇచ్చి, తోరగ్రంథి పూజ చేసి, తోరబంధన మంత్రం పఠిస్తూ, ఆ నవసూత్రాన్ని కుడిచేతికి కట్టుకొనవలెను. నవకాయ పిండివంటలూ, పండ్లూ మొదలైన వాటిని అమ్మవారికి సమర్పించి. చివరగా వాయనదాన మంత్రం పఠిస్తూ ఒక ముత్తైదువకు తాంబూలం సమర్పిస్తూ ఆమెని మహాలక్ష్మీగా భావించి వాయనమీయవలెను.',
        },
        {
          "title": '',
        },
        {
          "title": '@వరలక్ష్మి వ్రతం పూజ సామగ్రి :',
        },
        {
          "title": '',
        },
        {
          "title": 'పసుపు, కుంకుమ, గంధం, విడిపూలు, పూల మాలలు, పసుపు అక్షతలు,తమలపాకులు, 30 వక్కలు, ఖర్జూరాలు, అగరవత్తులు, కర్పూరం, చిల్లర పైసలు, తెల్లని వస్త్రం, రవిక దుస్తులు, మామిడి ఆకులు, ఐదు రకాల పండ్లు, అమ్మవారి ఫోటో, కలశం, కొబ్బరి కాయలు, గంట, హారతి పళ్లెము, ఆచమనమునకు గ్లాసు ప్రక్కన పళ్ళెము, చెంచాలు, ఒక రవికె గుడ్డ, తెల్ల దారం లేదా నోము దారం, లేదా పసుపు రాసిన కంకణం, ఇంటిలో తయారుచేసిన నైవేధ్యాలు, జ్యోతులు తొమ్మిది బియ్యపు పిండి బెల్లముతో కలిపి చేసినవి, నానబోసిన శనగలు, బియ్యం, పంచామృతాలు. దీపపు కుందులు, ఒత్తులు, నెయ్యి.'
        },
        {
          "title": '',
        },
        {
          "title": '@తోరం తయారు చేసుకొనే విధానము :',
        },
        {
          "title": '',
        },
        {
          "title": 'తెల్లటి దారాన్ని ఐదు లేక తొమ్మిది పోగులు తీసుకుని దానికి పసుపు రాయాలి. ఆ దారానికి ఐదు లేక తొమ్మిది పూలు కట్టి ముడులు వేయాలి. అంటే ఐదు లేక తొమ్మిది పోగుల దారాన్ని ఉపయోగించి, ఐదు లేక తొమ్మిది పువ్వులతో, ఐదు లేక తొమ్మిది ముడులతో తోరాలను తయారుచేసుకుని, పీఠం వద్ద ఉంచి పుష్పాలు, పసుపు, కుంకుమ, అక్షతలు వేసి, తోరాలను పూజించి ఉంచుకోవాలి. ఆవిధంగా తోరాలను తయారుచేసుకున్న తరువాత పూజకు సిద్ధంకావాలి.',
        },
        {
          "title": '',
        },
        {
          "title": '@గణపతి పూజా విధానము :',
        },
        {
          "title": '',
        },
        {
          "title": 'అదౌ నిర్విఘ్నేన వ్రత పరిసమాప్త్యర్థం గణపతి పూజాం కరష్యే',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్లో: వక్రతుండ మహాకాయ కోటి సూర్య సమప్రభ |',
        },
        {
          "title": 'నిర్విఘ్నం కురుమేదేవో సర్వ కార్యేషు సర్వదా ||',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్లో: ఆగచ్చ వరసిద్ధ వినాయక, అంబికా ప్రియనందన |',
        },
        {
          "title": 'పూజాగృహాణ సుముఖ, నమస్తే గణనాయక ||',
        },
        {
          "title": '',
        },
        {
          "title": 'అని స్తుతిస్తూ గణపతిపై అక్షతలు చల్లాలి. యధాశక్తి షోడశోపచార పూజ చేయాలి.',
        },
        {
          "title": '',
        },
        {
          "title": '@షోడశోపచార పూజ :',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం సుముఖాయ నమః,',
        },
        {
          "title": 'ఓం ఏకదంతాయ నమః,',
        },
        {
          "title": 'ఓం కపిలాయ నమః,',
        },
        {
          "title": 'ఓం గజకర్ణికాయ నమః,',
        },
        {
          "title": 'ఓం లంబోదరాయ నమః,',
        },
        {
          "title": 'ఓం వికటాయ నమః,',
        },
        {
          "title": 'ఓం విఘ్నరాజాయ నమః,',
        },
        {
          "title": 'ఓం గణాధిపాయ నమః,',
        },
        {
          "title": 'ఓం ధూమకేతవే నమః,',
        },
        {
          "title": 'ఓం వక్రతుండాయ నమః,',
        },
        {
          "title": 'ఓం గణాధ్యక్షాయ నమః,',
        },
        {
          "title": 'ఓం ఫాలచంద్రాయ నమః,',
        },
        {
          "title": 'ఓం గజాననాయ నమః,',
        },
        {
          "title": 'ఓం శూర్పకర్ణాయ నమః,',
        },
        {
          "title": 'ఓం హేరంబాయ నమః,',
        },
        {
          "title": 'ఓం స్కంద పూర్వజాయ నమః,',
        },
        {
          "title": 'ఓం శ్రీ మహాగణాధిపతయే నమః',
        },
        {
          "title": '',
        },
        {
          "title": 'నానావిధ పరిమళ పత్ర పుష్పాణి  అక్షతాన్ సమర్పయామి, అంటూ స్వామిపై పుష్పాలు ఉంచాలి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం శ్రీ మహాగణాధిపతయే నమః - ధూపం ఆఘ్రాపయామి,',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం శ్రీ మహాగణాధిపతయే నమః - దీపం దర్శయామి.',
        },
        {
          "title": '',
        },
        {
          "title": 'స్వామి వారి ముందు పళ్ళుగానీ, బెల్లాన్ని గానీ నైవేద్యంగా పెట్టాలి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం భూర్భువస్సువః తత్సవితుర్వర్యేణ్యం | ',
        },
        {
          "title": 'భర్గోదేవస్య ధీమహి ధియోయోనః ప్రచోదయాత్ ||',
        },
        {
          "title": '',
        },
        {
          "title": 'గాయత్రీ మంత్రాన్ని జపిస్తూ నీటిని నివేదన చేసి చుట్టూ జల్లుతూ, సత్యం త్వర్తేన పరిషించామి, అమృతమస్తు, అమృతో పస్తరణమసి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం ప్రాణాయ స్వాహా, ఓం ఆపానాయ స్వాహా, ఓం వ్యానాయస్వాహా, ఓం ఉదానాయ స్వాహా, ఓం సమానాయ స్వాహా, ఓం బ్రహ్మేణ్యే స్వాహా గుడ సహిత ఫల నివేదనం సమర్పయామి, మధ్యే మధ్యే పానీయం సమర్పయామి అని నీటిని వదలాలి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం శ్రీ మహాగణాధిపతయే నమః -  తాంబూలం సమర్పయామి, తాంబూలానంతరం అచమనం సమర్పయామి.',
        },
        {
          "title": 'ఓం శ్రీ మహాగణాధిపతయే నమః - కర్పూర నీరాజనం సమర్పయామి, నీరాజనానంతరం ఆచమనీయం సమర్పయామి.',
        },
        {
          "title": 'అనేన మాయా చరిత గణపతి అర్చనేన భగవతః సర్వాత్మకః శ్రీ గణపతిర్దేవతా సుప్రీతసుప్రసన్న వరదాభవతు. మమ ఇష్టకామ్యార్థ సిద్ధిరస్తు.',
        },
        {
          "title": 'వినాయకునికి నమస్కరించి పూజ చేసిన అక్షతలు తలమీద వేసుకోవాలి.',
        },
        {
          "title": 'మహాగణపతి పూజను ముగించిన అనంతరం వరలక్ష్మీ వ్రతాన్ని ప్రారంభించాలి.',
        },
        {
          "title": '',
        },
        {
          "title": '@కలశ పూజ :',
        },
        {
          "title": '',
        },
        {
          "title": 'కలశస్య ముఖే విష్ణు కంఠే రుద్రసమాశ్రితాః',
        },
        {
          "title": 'మూలేతత్ర స్థితో బ్రహ్మ మధ్యే మాతృగణః స్థితాః',
        },
        {
          "title": 'కుక్షౌతుస్సాగరస్సర్వే సప్తద్వీపా వసుంధరా',
        },
        {
          "title": 'ఋగ్వేదోధ యజుర్వేదో స్సామవేదో అధర్వణః',
        },
        {
          "title": 'అంగైశ్చ స్సహితా స్సర్వే కలశాంబు సమాశ్రితాః',
        },
        {
          "title": 'ఆయాంతు గణపతి పూజార్థం దురితక్షయకారకాః గంగేచ యమునేచైవ గోదావరి సరస్వతి నర్మదే సింధూ కావేరి జలేస్మిన్ సన్నిధిం కురు. అంటూ శ్లోకాన్ని చదివి కలశంలోని నీటిని పుష్పంతో ముంచి భగవంతుడిపై, పూజాద్రవ్యాలపై, పూజ చేస్తున్నవారు తలపైన చల్లుకోవాలి.',
        },
        {
          "title": '',
        },
        {
          "title": '@అధాంగపూజ:',
        },
        {
          "title": '',
        },
        {
          "title": 'పువ్వులు లేదా అక్షతలతో కలశానికి పూజ చేయాలి.',
        },
        {
          "title": 'చంచలాయై నమః - పాదౌ పూజయామి,',
        },
        {
          "title": 'చపలాయై నమః - జానునీ పూజయామి,',
        },
        {
          "title": 'పీతాంబరాయైనమః - ఉరుం పూజయామి,',
        },
        {
          "title": 'కమలవాసిన్యైనమః - కటిం పూజయామి,',
        },
        {
          "title": 'పద్మాలయాయైనమః - నాభిం పూజయామి,',
        },
        {
          "title": 'మదనమాత్రేనమః - స్తనౌ పూజయామి,',
        },
        {
          "title": 'కంబుకంఠ్యై నమః - కంఠం పూజయామి,',
        },
        {
          "title": 'సుముఖాయైనమః - ముఖంపూజయామి,',
        },
        {
          "title": 'సునేత్రాయైనమః - నేత్రౌపూజయామి,',
        },
        {
          "title": 'రమాయైనమః - కర్ణౌ పూజయామి,',
        },
        {
          "title": 'కమలాయైనమః - శిరః పూజయామి,',
        },
        {
          "title": 'శ్రీ వరలక్ష్య్మైనమః - సర్వాణ్యంగాని పూజయామి.',
        },
        {
          "title": '(ఆ తరువాత పుష్పాలతో అమ్మవారిని ఈ అష్టోత్తర శతనామాలతో పూజించాలి)',
        },
        {
          "title": '',
        },
        {
          "title": '@వరలక్ష్మీ అష్టోత్తర శతనామావళి :',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం ప్రకృత్యై నమః',
        },
        {
          "title": 'ఓం వికృత్యై నమః',
        },
        {
          "title": 'ఓం విద్యాయై నమః',
        },
        {
          "title": 'ఓం సర్వభూతహితప్రదాయై నమః',
        },
        {
          "title": 'ఓం శ్రద్ధాయై నమః',
        },
        {
          "title": 'ఓం విభూత్యై నమః',
        },
        {
          "title": 'ఓం సురభ్యై నమః',
        },
        {
          "title": 'ఓం పరమాత్మికాయై నమః',
        },
        {
          "title": 'ఓం వాచే నమః',
        },
        {
          "title": 'ఓం పద్మాలయాయై నమః || 10 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం పద్మాయై నమః',
        },
        {
          "title": 'ఓం శుచ్యై నమః',
        },
        {
          "title": 'ఓం స్వాహాయై నమః',
        },
        {
          "title": 'ఓం స్వధాయై నమః',
        },
        {
          "title": 'ఓం సుధాయై నమః',
        },
        {
          "title": 'ఓం ధన్యాయై నమః',
        },
        {
          "title": 'ఓం హిరణ్మయ్యై నమః',
        },
        {
          "title": 'ఓం లక్ష్మ్యై నమః',
        },
        {
          "title": 'ఓం నిత్యపుష్టాయై నమః',
        },
        {
          "title": 'ఓం విభావర్యై నమః || 20 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం అదిత్యై నమః',
        },
        {
          "title": 'ఓం దిత్యై నమః',
        },
        {
          "title": 'ఓం దీప్తాయై నమః',
        },
        {
          "title": 'ఓం వసుధాయై నమః',
        },
        {
          "title": 'ఓం కమలాయై నమః',
        },
        {
          "title": 'ఓం కాంతాయై నమః',
        },
        {
          "title": 'ఓం కామాక్ష్యై నమః',
        },
        {
          "title": 'ఓం క్రోధసంభవాయై నమః',
        },
        {
          "title": 'ఓం అనుగ్రహపరాయై నమః || 30 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం ఋద్ధయే నమః',
        },
        {
          "title": 'ఓం అనఘాయై నమః',
        },
        {
          "title": 'ఓం హరివల్లభాయై నమః',
        },
        {
          "title": 'ఓం అశోకాయై నమః',
        },
        {
          "title": 'ఓం అమృతాయై నమః',
        },
        {
          "title": 'ఓం దీప్తాయై నమః',
        },
        {
          "title": 'ఓం లోకశోక వినాశిన్యై నమః',
        },
        {
          "title": 'ఓం ధర్మనిలయాయై నమః',
        },
        {
          "title": 'ఓం కరుణాయై నమః',
        },
        {
          "title": 'ఓం లోకమాత్రే నమః || 40 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం పద్మప్రియాయై నమః',
        },
        {
          "title": 'ఓం పద్మహస్తాయై నమః',
        },
        {
          "title": 'ఓం పద్మాక్ష్యై నమః',
        },
        {
          "title": 'ఓం పద్మసుందర్యై నమః',
        },
        {
          "title": 'ఓం పద్మోద్భవాయై నమః',
        },
        {
          "title": 'ఓం పద్మముఖ్యై నమః',
        },
        {
          "title": 'ఓం పద్మనాభప్రియాయై నమః',
        },
        {
          "title": 'ఓం రమాయై నమః',
        },
        {
          "title": 'ఓం పద్మమాలాధరాయై నమః',
        },
        {
          "title": 'ఓం దేవ్యై నమః || 50 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం పద్మిన్యై నమః',
        },
        {
          "title": 'ఓం పద్మగంథిన్యై నమః',
        },
        {
          "title": 'ఓం పుణ్యగంధాయై నమః',
        },
        {
          "title": 'ఓం సుప్రసన్నాయై నమః',
        },
        {
          "title": 'ఓం ప్రసాదాభిముఖ్యై నమః',
        },
        {
          "title": 'ఓం ప్రభాయై నమః',
        },
        {
          "title": 'ఓం చంద్రవదనాయై నమః',
        },
        {
          "title": 'ఓం చంద్రాయై నమః',
        },
        {
          "title": 'ఓం చంద్రసహోదర్యై నమః',
        },
        {
          "title": 'ఓం చతుర్భుజాయై నమః || 60 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం చంద్రరూపాయై నమః',
        },
        {
          "title": 'ఓం ఇందిరాయై నమః',
        },
        {
          "title": 'ఓం ఇందుశీతులాయై నమః',
        },
        {
          "title": 'ఓం ఆహ్లోదజనన్యై నమః',
        },
        {
          "title": 'ఓం పుష్ట్యై నమః',
        },
        {
          "title": 'ఓం శివాయై నమః',
        },
        {
          "title": 'ఓం శివకర్యై నమః',
        },
        {
          "title": 'ఓం సత్యై నమః',
        },
        {
          "title": 'ఓం విమలాయై నమః',
        },
        {
          "title": 'ఓం విశ్వజనన్యై నమః || 70 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం తుష్ట్యై నమః',
        },
        {
          "title": 'ఓం దారిద్ర్య నాశిన్యై నమః',
        },
        {
          "title": 'ఓం ప్రీతిపుష్కరిణ్యై నమః',
        },
        {
          "title": 'ఓం శాంతాయై నమః',
        },
        {
          "title": 'ఓం శుక్లమాల్యాంబరాయై నమః',
        },
        {
          "title": 'ఓం శ్రియై నమః',
        },
        {
          "title": 'ఓం భాస్కర్యై నమః',
        },
        {
          "title": 'ఓం బిల్వనిలయాయై నమః',
        },
        {
          "title": 'ఓం వరారోహాయై నమః',
        },
        {
          "title": 'ఓం యశస్విన్యై నమః || 80 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం వసుంధరాయై నమః',
        },
        {
          "title": 'ఓం ఉదారాంగాయై నమః',
        },
        {
          "title": 'ఓం హరిణ్యై నమః',
        },
        {
          "title": 'ఓం హేమమాలిన్యై నమః',
        },
        {
          "title": 'ఓం ధనధాన్య కర్యై నమః',
        },
        {
          "title": 'ఓం సిద్ధయే నమః',
        },
        {
          "title": 'ఓం స్త్రైణ సౌమ్యాయై నమః',
        },
        {
          "title": 'ఓం శుభప్రదాయై నమః',
        },
        {
          "title": 'ఓం నృపవేశ్మ గతానందాయై నమః',
        },
        {
          "title": 'ఓం వరలక్ష్మ్యై నమః || 90 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం వసుప్రదాయై నమః',
        },
        {
          "title": 'ఓం శుభాయై నమః',
        },
        {
          "title": 'ఓం హిరణ్యప్రాకారాయై నమః',
        },
        {
          "title": 'ఓం సముద్ర తనయాయై నమః',
        },
        {
          "title": 'ఓం జయాయై నమః',
        },
        {
          "title": 'ఓం మంగళాయై నమః',
        },
        {
          "title": 'ఓం దేవ్యై నమః',
        },
        {
          "title": 'ఓం విష్ణు వక్షఃస్థల స్థితాయై నమః',
        },
        {
          "title": 'ఓం విష్ణుపత్న్యై నమః',
        },
        {
          "title": 'ఓం ప్రసన్నాక్ష్యై నమః || 100 ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓం నారాయణ సమాశ్రితాయై నమః',
        },
        {
          "title": 'ఓం దారిద్ర్య ధ్వంసిన్యై నమః',
        },
        {
          "title": 'ఓం సర్వోపద్రవ వారిణ్యై నమః',
        },
        {
          "title": 'ఓం నవదుర్గాయై నమః',
        },
        {
          "title": 'ఓం మహాకాళ్యై నమః',
        },
        {
          "title": 'ఓం బ్రహ్మ విష్ణు శివాత్మికాయై నమః',
        },
        {
          "title": 'ఓం త్రికాల జ్ఞాన సంపన్నాయై నమః',
        },
        {
          "title": 'ఓం భువనేశ్వర్యై నమః || 108 ||',
        },
        {
          "title": 'నానావిధ పరిమళ పత్ర పుష్పాణి అక్షతాన్ సమర్పయామి, అంటూ స్వామిపై పుష్పాలు ఉంచాలి.',
        },
        {
          "title": '',
        },
        {
          "title": '@తోరపూజ :',
        },
        {
          "title": '',
        },
        {
          "title": 'తోరాన్ని అమ్మవారి వద్ద ఉంచి అక్షతలతో ఈ విధంగా పూజ చేయాలి.',
        },
        {
          "title": '',
        },
        {
          "title": 'కమలాయైనమః - ప్రథమ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'రమాయైనమః - ద్వితీయ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'లోకమాత్రేనమః - తృతీయ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'విశ్వజనన్యైనమః - చతుర్థ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'మహాలక్ష్మ్యై నమః - పంచమ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'క్షీరాబ్ది తనయాయై నమః - షష్ఠమ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'విశ్వసాక్షిణ్యై నమః - సప్తమ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'చంద్రసోదర్యైనమః - అష్టమ గ్రంథిం పూజయామి,',
        },
        {
          "title": 'శ్రీ వరలక్ష్మీయై నమః - నవమ గ్రంథిం పూజయామి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఈ కింది శ్లోకము చదువుతూ తోరం కట్టుకోవాలి.',
        },
        {
          "title": 'శ్లో: బద్నామి దక్షిణేహస్తే నవసూత్రం శుభప్రదం |',
        },
        {
          "title": 'పుత్రపౌత్రాభివృద్ధించ మమ సౌభాగ్యం దేహిమే రమే ||',
        },
        {
          "title": '',
        },
        {
          "title": '@వ్రత కథా ప్రారంభం :',
        },
        {
          "title": '',
        },
        {
          "title": 'పూర్వం శౌనకాది మహర్షులను ఉద్దేశించి సూత మహర్షి ఇలా చెప్పారు. మునులారా! స్త్రీలకు సౌభాగ్యాన్ని ప్రసాదించే ఒక వ్రతాన్ని పరమ శివుడు పార్వతికి చెప్పారు. లోకోపకారం కోరి ఆ వ్రతాన్ని గురించి మీకు తెలియజేస్తాను శ్రద్ధగా వినండి అన్నారు. పరమేశ్వరుడు ఒకనాడు తన భస్మసింహాసనంపై కూర్చుని ఉండగా నారదమహర్షి, ఇంద్రాది దిక్పాలకులు స్తుతి స్తోత్రాలతో ఆయను కీర్తిస్తున్నారు. ఆమహత్తర ఆనంద సమయంలో పార్వతీదేవి పరమేశ్వరుడ్ని ఉద్దేశించి నాథా! స్త్రీలు సర్వసౌఖ్యాలు పొంది, పుత్ర పౌత్రాభివృద్ధిగా తరించుటకు తగిన వ్రతం ఒకదానిని చెప్పండి అని కోరింది. అందుకా త్రినేత్రుడు దేవీ! నీవు కోరిన విధంగా స్త్రీలకు సకల శుభాలు కలిగించే వ్రతం ఒకటి ఉన్నది. అది వరలక్ష్మీవ్రతం. దానిని శ్రావణమాసం రెండో శుక్రవారం నాడు ఆచరించాలని తెలిపాడు.',
        },
        {
          "title": '',
        },
        {
          "title": 'అప్పుడు పార్వతీదేవి దేవా! ఈ వరలక్ష్మీ వ్రతాన్ని ఆది దేవతలు ఎవరుచేశారు? ఈ వ్రతాన్ని ఎలా చేయాలో వివరంగా చెప్పండని కోరింది. కాత్యాయనీ పూర్వకాలంలో మగధ దేశంలో కుండినం అనే పట్టణం ఒకటి ఉండేది. ఆ పట్టణం బంగారు కుడ్యములతో రమణీయంగా ఉండేది. ఆ పట్టణంలో చారుమతి అనే ఒక బ్రాహ్మణ స్త్రీ ఉండేది. ఆమె సుగుణవతి. వినయ విధేయతలు, భక్తి గౌరవాలు గలయోగ్యురాలు. ప్రతిరోజూ ప్రాతఃకాలాన నిద్రలేచి భర్త పాదాలకు నమస్కరించి ప్రాతఃకాల గృహకృత్యాలను పూర్తిచేసుకుని అత్తమామలను సేవలో తరించేంది.',
        },
        {
          "title": '',
        },
        {
          "title": '@వరలక్ష్మీ సాక్షాత్కారం :',
        },
        {
          "title": '',
        },
        {
          "title": 'వరలక్ష్మీ వ్రతానికి ఆది దేవతయైన వరలక్ష్మీ దేవి ఒకనాటి రాత్రి సమయంలో చారుమతికి కలలో సాక్షాత్కరించింది. ఓ చారుమతీ ఈ శ్రావణ పౌర్ణమి నాటికి ముందు వచ్చే శుక్రవారం నాడు నన్ను పూజించు, నీవు కోరిన వరాలు, కానుకలను ఇస్తానని చెప్పి అంతర్థానమైంది. చారుమతి సంతోషించి, హే జననీ! నీకృపా కటాక్షాలు కలిగిన వారు ధన్యులు. వారు సంపన్నులుగా, విద్వాంసులుగా మన్ననలు పొందుతారు. ఓ పావనీ! నా పూర్వజన్మ సుకృతం వల్ల నీ దర్శనం నాకుకలిగింది అని పరిపరివిధాల వరలక్ష్మీని స్తుతించింది.',
        },
        {
          "title": '',
        },
        {
          "title": 'అంతలోనే మేల్కొన్న చారుమతి అదంతా కలగా గుర్తించి తన కలను భర్తకు, అత్తమామలకు తెలియజేసింది. వారు చాలా సంతోషించి చారుమతిని వరలక్ష్మీ వ్రతాన్ని చేసుకోమని చెప్పారు. ఆ పట్టణంలోని మహిళలు చారుమతి కలను గురించి విని వారు కూడా పౌర్ణమి ముందు రాబోయే శ్రావణ శుక్రవారం కోసం ఎదురుచూడసాగారు.',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్రావణ శుక్రవారం రోజున పట్టణంలోని స్త్రీలందరూ ఉదయాన్నే లేచి తలారాస్నానం చేసి పట్టువస్త్రాలు ధరించి చారుమతి గృహానికి చేరుకున్నారు. చారుమతి తన గృహంలో మండపం ఏర్పాటుచేసి ఆ మండపంపై బియ్యంపోసి పంచపల్లవాలైన రావి, జువ్వి, మర్రి, మామిడి, ఉత్తరేణి మొదలైన ఆకులతో కలశం ఏర్పాటు చేసి వరలక్ష్మీదేవిని సంకల్ప విధులతో సర్వమాంగళ మాంగళ్యే శివే సర్వార్థసాధికే శరణ్యే త్రయంబకే దేవీ నారాయణి నమోస్తుతే ! అంటూ ఆహ్వానించి ప్రతిష్టించింది. అమ్మవారిని షోడశోపచారాలతో పూజించి, భక్ష్య, భోజ్యాలను నివేదించారు. తొమ్మిది పోగుల తోరాన్ని చేతికి కట్టుకుని, ప్రదక్షిణ నమస్కారాలు చేశారు.',
        },
        {
          "title": '',
        },
        {
          "title": 'మొదటి ప్రదక్షిణ చేయగానే కాలి అందియలు ఘల్లుఘల్లున మోగాయి. రెండో ప్రదక్షిణ చేయగానే హస్తాలకు నవరత్నఖచిత కంకణాలు ధగధగా మెరవసాగాయి. మూడో ప్రదక్షిణ చేయగానే అందరూ సర్వాభరణభూషితులయ్యారు. వారు చేసిన వరలక్ష్మీ వ్రతం ఫలితంగా చారుమతి గృహంతో పాటు, ఆపట్టణంలో ఇతర స్త్రీల ఇళ్లు కూడా ధన, కనక, వస్తు వాహనాలతో నిండిపోయాయి. వారి వారి ఇళ్ల నుంచి గజతరగరథ వాహనాలతో వచ్చి ఇళ్లకు తీసుకెళ్లారు. వారంతా మార్గమధ్యంలో చారుమతిని వేనోళ్ళ పొగుడుతూ ఆమెకు వరలక్ష్మీ దేవి కలలో సాక్షాత్కరించి అనుగ్రహించగా ఆమె చేసిన వ్రతంతో తమని కూడా మహద్భాగ్యవంతులను చేసిందని ప్రశంసించారు. వారంతా ఏటా వరలక్ష్మీవ్రతం చేసి సకల సౌభాగ్యాలతో సిరిసంపదలు కలిగి, సుఖజీవనం గడిపి ముక్తిని పొందారు.',
        },
        {
          "title": '',
        },
        {
          "title": 'మునులారా! శివుడు పార్వతికి ఉపదేశించిన ఈ వరలక్ష్మీ వ్రత విధానాన్ని సవిస్తరంగా మీకు వివరించాను. ఈ కథ విన్నా, ఈ వ్రతం చేసినా, ఈ వ్రతం చేసినప్పుడు చూసినా కూడా సకల సౌభాగ్యాలు, సిరిసంపదలు, ఆయురారోగ్వైశ్వర్యాలు సిద్ధిస్తాయని సూత మహాముని శౌనకాది మహర్షులకు చెప్పారు. ఈ కథ విని అక్షతలు శిరసుపై వేసుకోవాలి. ఆ తరువాత ముత్తైదువులకు తాంబూలాలు ఇవ్వాలి. అందరికీ తీర్థప్రసాదాలు ఇచ్చి, పూజ చేసినవారు కూడా వాటిని తీసుకోవాలి. అమ్మవారికి పెట్టిన నైవేద్యాన్ని వాళ్లే ఆరగించాలి. రాత్రి ఉపవాసం ఉండి, భక్తితో వేడుకుంటటే వరాలందించే తల్లి వరలక్ష్మీ దేవి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఈ వ్రతాన్ని ఆచరించడానికి ఏ నిష్ఠలు, నియమాలు, మడులు అవసరం లేదు. నిశ్చలమైన భక్తి, ఏకాగ్రచిత్తం ఉంటే చాలు. వరలక్ష్మీవ్రతం ఎంతో మంగళకరమైంది. ఈ వ్రతాన్నిచేయడంవల్ల లక్ష్మీదేవి కృప కలిగి ఐశ్వర్యం లభిస్తుంది. సకల శుభాలుకలుగుతాయి. స్త్రీలు దీర్ఘకాలం సుమంగళిగా ఉండేందుకు ఈ వ్రతం ఆచరించడం తప్పనిసరి.',
        },
        {
          "title": '',
        },
      ],
      "title": 'వరలక్ష్మీ వ్రతం',
    },
    "ugadi": {
      "CatID": [
        // {
        //   "title":
        //     '@ఉగాది',
        // },
        // {
        //   "title": '',
        // },
        {
          "title": 'ఆ పర్వదినము రోజున ప్రాతః కాలమున అనగా సూర్యోదయానికి ముందే నిద్రలేచి ఇంటిని శుభ్రపరచుకొని, తలంటు స్నానం చేసి ఉతికిన వస్త్రాలు ధరించి మామిడి తోరణములతో ఇంటిని అలంకరించాలి. ఆ తర్వాత దైవానికి పుష్పార్చన,అర్ఘ్యం,ధూప దీపాదులను సమర్పించి వేప పచ్చడిని స్వీకరించాలి. పచ్చడి స్వీకరించే ముందు ఎలాంటి ఆహార పదార్ధాలను తినకూడదు.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఉగాది చైత్రమాసంలో మొదలవుతుంది. ఆ రోజును తెలుగు సంవత్సరపు మొదటి రోజుగా పరిగణిస్తాం. అరవై సంవత్సరాలు ప్రభవతో మొదలై, అక్షయతో పూర్తవుతాయి. ‘ఉగ’ అంటే నక్షత్ర గమనం. ఆ నక్షత్ర గమనానికి ఆది "ఉగాది". ఆ ప్రకారంగా సృష్టి ఆరంభమైన సుముహూర్తమే "ఉగాది".',
        },
        {
          "title": '',
        },
        {
          "title":
            'చైత్ర శుద్ధ పాడ్యమి నాడు వచ్చే ఈ పర్వదినానికి ఎంతో ప్రాముఖ్యత ఉంది. ఈ నూతన సంవత్సరంలో రాశిఫలాలు, గ్రహస్థితులు ఎలా ఉన్నాయో తెలుసుకొని గ్రహశాంతులు జరిపించుకొని సుఖంగా ఉండేందుకు పంచంగ శ్రవణాన్ని చేస్తారు.',
        },
        {
          "title": '',
        },
        {
          "title":
            'చైత్రమాసం శుక్లపక్ష పాడ్యమి రోజున ఆ విధాత ఈ జగత్తును సృష్టించాడని నమ్ముతారు. సోమకుడు వేదాలను తస్కరించిన కారణంగా మత్సావతారం ధరించిన విష్ణువు అతడిని సంహరించి వాటిని తిరిగి బ్రహ్మదేవుడికి అప్పగించిన సందర్భంగా "ఉగాది" ఆచరణలోకి వచ్చిందని పురాణప్రతీతి. చైత్ర శుద్ధ పాడ్యమి రోజున సూర్యోదయ వేళలో బ్రహ్మ దేవుడు సృష్టిని సృష్టించాడని అంటారు. అంటే కాలగణాన్ని గ్రహ, నక్షత్ర, ఋతు, మాస, వర్ష, వర్షాధికులను బ్రహ్మదేవుడు ఆ రోజు వర్తింపజేస్తాడని నమ్మకం. అంతేకాకుండా వసంత ఋతువు కూడా ఈ రోజు నుంచే ప్రారంభమవుతుంది. అందుకే నూతన జీవితానికి నాందిగా "ఉగాది" పండుగను జరుపుకుంటారు.',
        },
        {
          "title": '',
        },
        {
          "title":
            'వసంతఋతువు ప్రతి చెట్లు పచ్చని చిగుర్లతో కళకళలాడే ఋతువు. ఋతువుల్లో ఆఖరి ఋతువు "శిశిరఋతువు". ఈ శిశిరఋతువులో చెట్ల ఆకులు రాలిపోతాయి. వసంతఋతువుతో చెట్లన్నీ చిగురిస్తాయి. దీంతో ఎక్కడ చూసినా పచ్చదనమే కనిపిస్తుంది. ఉగాది పండగతో వసంత ఋతువు ఆరంభం అవుతుంది. ఋతువుల రాణీ వసంతఋతువు. తెలుగు నెలలైన చైత్ర, వైశాఖ మాసాలను వసంతఋతువు కనువిందు చేస్తుంది. వసంతఋతువు తరువాత గ్రీష్మఋతువు వస్తుంది.ఇలా కాలచక్రంలో ఆరు ఋతువులు ఈ పర్యావరణాన్ని నడిపిస్తుంటాయి.',
        },
        {
          "title": '',
        },
        {
          "title":
            'ఉగాది సందర్భంగా వసంతఋతువులోకి ప్రవేశిస్తున్న కారణంగా శారీరకంగా, మానసికంగా తలెత్తే మార్పుల్ని కట్టడి చేసి ఆరోగ్యాన్ని పదిలంగా ఉంచుకోవడానికి ఉగాది పచ్చడి దోహదం చేస్తుంది. ఇందులో ఉండే ఆయుర్వేద గుణాలు చాలా రకాల అనారోగ్య సమస్యల నుంచి ఉపశమనం కలిగిస్తాయి. ఈ పచ్చడి మన జీవితంలో జరిగే సుఖ దుఃఖాలను సూచిస్తుంది. ఇందులోని రుచులలో ఒక్కో దానికి ఒక్కో అర్థం ఉంది. షడ్రచుల సమ్మేళనంగా చేసే ఈ పచ్చడి జీవితంలో జరిగే వివిధ అనుభవాలను సూచిస్తుంది.',
        },
        {
          "title": '',
        },
        {
          "title":
            'ఉప్పు : దీనిని జీవితంలో ఆనందం, రుచికి సంకేతంగా పరిగణిస్తారు. ఇది రుచిని, భయాన్ని సూచిస్తుంది. ఉప్పు మన శరీరానికి చేసే మేలు అంతా ఇంతా కాదు. జీర్ణశక్తిని పెంచి ఆరోగ్యంగా ఉంచుతుంది. ఆకలిని కలిగిస్తుంది. కానీ ఉప్పును అధికంగా వాడకూడదు.',
        },
        {
          "title": '',
        },
        {
          "title":
            'పులుపు : పులుపు తెలివిగా వ్యవహరించాల్సిన పరిస్థితులను తెలియజేస్తుంది. ఎలాంటి పరిస్థితులకైనా ఓర్పుగా ఉండాలని సూచిస్తుంది. జీర్ణశక్తిని పెంచడానికి కీలక పాత్ర పోషిస్తుంది. చర్మ సమస్యలను తగ్గించడానికి సహాయపడుతుంది. శరీరంలోని కొలెస్ట్రాల్ స్థాయిలను తగ్గిస్తుంది.',
        },
        {
          "title": '',
        },
        {
          "title":
            'వేప పువ్వు : బాధను దిగమింగాలని లేదా భరించాలని సూచిస్తుంది. వేపపూత మన ఆరోగ్యానికి ఎంతో మేలు చేస్తుంది. ఇది మన శరీరంలో ఉండే వ్యర్థాలను తొలగిస్తుంది. రక్తమును శుద్ధి చేస్తుంది. మామిడి, చింతపండుతో పాటు వేపను తీసుకోవడం వల్ల శరీరంలో రోగనిరోధక శక్తి పెరిగి బాడీలోని విషపదార్థాలు బయటకి వస్తాయి.',
        },
        {
          "title": '',
        },
        {
          "title":
            'బెల్లం : ఈ తియ్యని పదార్థం సంతోషానికి ప్రతీకగా భావిస్తారు. కొత్త బెల్లాన్ని తింటే మనకు ఆకలి కలగడమే కాక మనస్సు ప్రశాంతంగా ఉంటుంది. బెల్లం తినడం వల్ల కాలేయం శుభ్రపడుతుంది. ఇందులో ఉండే గుణాలు టాక్సిన్స్‌ను తొలగిస్తుంది. ఇది పిత్తం, వాతం సమస్యలను తగ్గిస్తుంది. కొత్త కణాలను ఏర్పరిచేందుకు సహాయపడుతుంది.',
        },
        {
          "title": '',
        },
        {
          "title":
            'కారం : సహనం కోల్పోవడాన్ని సూచిస్తుంది. మితంగా తీసుకుంటే ఇది శరీరాన్ని వెచ్చగా ఉంచుతుంది. జీవక్రియను పెంచుతుంది. బరువు తగ్గడానికి సహాయపడుతుంది. రోగ నిరోధక శక్తిని పెంచడానికి పనిచేస్తుంది.',
        },
        {
          "title": '',
        },
        {
          "title":
            'వగరు : పచ్చి మామిడి ముక్కల్లో తగిలే ఈ రుచి కొత్త సవాళ్లను ఎదుర్కోవడం గురించి తెలియజేస్తుంది. ఇవి శరీరాన్ని బలంగా చేస్తాయి. శరీరాన్ని వెచ్చగా ఉంచడంతో పాటు శరీర రోగ నిరోధక శక్తిని పెంచుతాయి. ప్రతి రోజూ తినడం వల్ల గ్యాస్ట్రిక్, గుండె సమస్యల నుంచి దూరం చేస్తుంది.',
        },
        {
          "title": '',
        },
        {
          "title":
            'షడ్రుచులతో కూడిన ప్రసాదాన్ని పంచాంగానికి, దేవతలకు నైవేద్యంగా సమర్పించి తమ భవిష్యత్‌ జీవితాలు ఆనందంగా సాగాలని ప్రార్థిస్తారు. ఇష్టంగా ఉగాది పచ్చడి తింటారు. కొత్త సంవత్సరంలో రాశిఫలాలు, గ్రహస్థితులు తెలుసుకునే కార్యక్రమమే పంచాగ శ్రవణం. తిథి, వార, నక్షత్ర, యోగ, కరణ ఫలితాన్ని తెలుసుకోవడం ద్వారా గంగాస్నానం చేసినంత పుణ్యాన్ని పొందవచ్చని పెద్దలంటారు. ప్రకృతితో ముడిపడిన ఈ పండుగ ప్రతి జీవికీ చైతన్యంతో కూడిన ఆనందాన్నిస్తుంది.',
        },
        {
          "title": '',
        },
      ],
      "title": 'ఉగాది',
    },
    "sriRamanavami": {
      "CatID": [
        // {
        //   "title":
        //     '@శ్రీరామనవమి',
        // },
        // {
        //   "title": '',
        // },
        {
          "title": 'శ్రీ రామనవమి పర్వదినము రోజున  ప్రాతః కాలమున అనగా సూర్యోదయానికి ముందే నిద్రలేచి, పూజా మందిరము, ఇంటిని శుభ్రపరచుకొని తలంటు స్నానం చేసి శుభ్రమైన వస్త్రాలు ధరించి మామిడి తోరణములతో ఇంటిని అలంకరించాలి. పూజామందిరమును పుష్పాలతోను, గడపలకు పసుపు, కుంకుమలతోనూ,  ఇంటి ముందు రంగవల్లికలతోనూ అలంకరించుకోవాలి. పూజకు ఉపయోగించే పటములకు గంధము, కుంకుమ పెట్టి సిద్ధంగా ఉంచాలి.',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్రీ సీతారామలక్ష్మణ, భరత, శతృఘ్నులతో కూడిన పటము లేదా ప్రతిమను గానీ పూజకు ఉపయోగించవచ్చు. పూజకు పువ్వులు, నైవేద్యానికి పానకం, వడపప్పు, పండ్లను సిద్ధం చేసుకోవాలి. అలాగే పూజకు ముందు శ్రీరామ అష్టోత్తరము, శ్రీరామరక్షా స్తోత్రము, శ్రీరామాష్టకము, శ్రీరామ సహస్రము, శ్రీమద్రామాయణం వంటి స్తోత్రాలతో శ్రీరాముడిని స్తుతించాలి. ఇంకా శ్రీరామ పట్టాభిషేకము అనే అధ్యాయమును పారాయణము చేయడం ద్వారా శుభఫలితాలు చేకూరుతాయి.',
        },
        {
          "title": '',
        },
        
        {
          "title": 'శ్రీ రామనవమి రోజున శ్రీరామ దేవాలయం దర్శించుకోవడం మంచిది. అలాగే దేవాలయాల్లో పంచామృతముతో అభిషేకం, శ్రీరామ ధ్యాన శ్లోకములు, శ్రీరామ అష్టోత్తర పూజ, సీతారామ కళ్యాణము వంటి పూజా కార్యక్రమాలను జరిపిస్తే అనుకున్న కార్యాలు దిగ్విజయంగా పూర్తికావడంతో పాటు సకలసంపదలు చేకూరుతాయి. అలాగే శ్రీరామనవమి రోజున శ్రీ రామదేవుని కథ వ్రతమును ఆచరించడం మంచిది. నవమిరోజున మధ్యాహ్నం 12 గంటలకు పూజ చేయాలి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ప్రతి సంవత్సరం చైత్ర శుద్ధ పాడ్యమి మొదలు అనగా ఉగాది నుంచి శ్రీరామనవమి వరకూ శ్రీ రామ కల్యాణ ఉత్సవాలను నిర్వహిస్తారు. భద్రాచలంలో రామదాసుచే కట్టబడిన రామాలయంలో, ప్రతి సంవత్సరం ఈ ఉత్సవం వైభవంగా చేస్తారు. స్వామివారి కల్యాణం అనంతరం భక్తులకు బెల్లం, మిరియాలతో తయారు చేసిన పానకాన్ని అందిస్తారు. అలాగే రామాయణాన్ని పారాయణ చేస్తారు. రాముల వారి కల్యాణంతో దేశం సిరి, సంపదలతో తులతూగుతుందని భక్తుల విశ్వాసం.',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్రీరామనవమి పండుగను మన తెలుగు లోగిళ్లలో చాలా వైభవంగా జరుపుకుంటారు. హిందువులు జరుపుకునే ముఖ్యమైన పండుగలలో శ్రీరామనవమి ఒకటి. శ్రీరాముడు వసంతఋతువులో చైత్ర శుద్ధ నవమి, గురువారం నాడు పునర్వసు నక్షత్రపు కర్కాటక లగ్నంలో సరిగ్గా అభిజిత్ ముహూర్తంలో అంటే మధ్యాహ్మం 12 గంటల సమయంలో త్రేతాయుగంలో జన్మించినట్లు పురాణాలు చెబుతున్నాయి.',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్రీరాముడి జన్మదినాన్ని శ్రీరామనవమి పండుగగా జరుపుకుంటారు. పదునాలుగు సంవత్సరములు అరణ్యవాసము, రావణ సంహారము తరువాత శ్రీరాముడు సీతా సమేతంగా అయోధ్యలో అడుగిడిన శుభ సంఘటన కూడా చైత్ర శుద్ధ నవమి నాడే జరిగినదని ప్రజల విశ్వాసము. శ్రీరాముడు పట్టాభిషేకం చేసుకున్నది, సీతారాముల కళ్యాణం జరిగినది ఇదే రోజున అని నమ్మకం.',
        },
        {
          "title": '',
        },
        {
          "title": 'అందుకే కొన్ని ప్రాంతాల్లో శ్రీరామనవమి రోజున శ్రీరాముడి జన్మదిన వేడుకలు జరుపుకుంటే, మరికొన్ని ప్రాంతాల్లో సీతారాముల కళ్యాణ ఉత్సవాన్ని జరుపుతారు. తెలంగాణలోని భద్రాచల మందు సీతారామ కళ్యాణ ఉత్సవాన్ని వైభవోపేతంగా జరుపుతారు. ఆంధ్రప్రదేశ్ లోని ఒంటిమిట్టలో మాత్రం చైత్ర మాస పూర్ణిమ నాడు రాత్రివేళ నిర్వహించడం ఆనవాయితీగా వస్తోంది.',
        },
        {
          "title": '',
        },
        {
          "title": 'రామాయణంలో అయోధ్యకు రాజైన దశరథునికి ముగ్గురు భార్యలు. వారు కౌసల్య, సుమిత్ర, కైకేయి. ఆయనకు ఉన్న బాధ అంతా సంతానం గురించే. సంతానం లేకపోతే రాజ్యానికి వారసులు ఉండరని. అప్పుడు వశిష్ట మహాముని రాజుకు పుత్ర కామేష్టి యాగం చేయమని సలహా ఇచ్చాడు. రుష్య శృంగ మహామునికి యజ్ఞాన్ని నిర్వహించే బాధ్యతను అప్పజెప్పమన్నాడు. వెంటనే దశరథుడు ఆయన ఆశ్రమానికి వెళ్ళి ఆయనను తన వెంట అయోధ్యకు తీసుకుని వచ్చాడు.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఆ యజ్ఞానికి తృప్తి చెందిన అగ్ని దేవుడు పాయసంతో నిండిన ఒక పాత్రను దశరథుని కిచ్చి భార్యలకు ఇవ్వమన్నాడు. దశరథుడు అందులో సగ భాగం మొదటి భార్య కౌసల్యకూ, రెండో సగ భాగం చిన్న భార్యయైన కైకేయికి ఇచ్చాడు. వారిద్దరూ వారి వాటాల్లో సగం మిగిల్చి రెండో భార్యయైన సుమిత్రకు ఇచ్చారు. కొద్దికాలానికే వారు ముగ్గురూ గర్భం దాల్చారు. చైత్ర మాసం తొమ్మిదవ రోజైన నవమి నాడు, మధ్యాహ్నం కౌసల్య రామునికి జన్మనిచ్చింది. అలాగే కైకేయి భరతుడికీ, సుమిత్ర లక్ష్మణ శతృఘ్నూలకు జన్మనిచ్చారు.',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్రీరాముడు ధర్మ సంస్థాపనార్థం అవతరించిన శ్రీ మహా విష్ణువు యొక్క ఏడవ అవతారం. ఒకసారి పార్వతీదేవి పరమశివుని "కేనోపాయేన లఘునా విష్ణోర్నామ సహస్రకం" అని, విష్ణు సహస్రనామ స్తోత్రమునకు కాస్త సూక్ష్మమైన మార్గం చెప్పమని కోరుతుంది.దానికి పరమేశ్వరుడు, "ఓ పార్వతీ! నేను నిరంతరము ఆ ఫలితము కొరకు జపించేది ఇదే సుమా!" అని ఈ క్రింది శ్లోకంతో మంత్రోపాసనచేస్తాడు.',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్లో|| శ్రీ రామ రామ రామేతి రమే రామే మనోరమే |',
        },
        {
          "title": 'సహస్ర నామతత్తుల్యం రామనామ వరాననే ||',
        },
        {
          "title": '',
        },
        {
          "title": 'ఈ శ్లోకం మూడుమార్లు స్మరించితే ఒక్క విష్ణు సహస్ర నామ పారాయణ ఫలితమే కాదు, భక్తులకు శివ సహస్రనామ ఫలితం కూడా లభిస్తుంది. దుష్ట శిక్షణ, శిష్ట రక్షణార్థమై చైత్రశుద్ధ నవమి నాడు ఐదు గ్రహాలు ఉచ్ఛస్థితిలో ఉన్న కాలమందు పునర్వసు నక్షత్రంతో కూడిన కర్కాటక లగ్నంలో పగటి సమయాన సాక్షాత్తు ఆ శ్రీహరియే కౌసల్యాపుత్రుడై ఈ భూమిపైన జన్మించిన పర్వదినాన్ని మనం "శ్రీరామనవమి" గా విశేషంగా జరుపుకుంటాం.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఏ భక్తులు కాశీలో జీవిస్తూ ఆ పుణ్యక్షేత్ర మందు మరణిస్తారో వారి మరణ సమయాన ఆ భక్త వశంకరుడే ఈతారక మంత్రం వారి కుడి చెవిలో చెప్పి, వారికి సధ్గతి కలిగిస్తాడన్నది భక్తుల ప్రగాఢ విశ్వాసం. ఇక భక్త రామదాసు అయితే శ్రీరామ నామ గానమధుపానాన్ని, భక్తితో సేవించి కీర్తించాడు.',
        },
        {
          "title": '',
        },
        {
          "title": 'మనం శ్రీరామ నామాన్ని ఉచ్ఛరించేటప్పుడు "రా" అనగానే మన నోరు తెరచుకుని మన లోపల పాపాలన్ని బయటకు వచ్చి ఆ రామ నామ అగ్నిజ్వాలలో పడి దహించుకుపోతాయట. అలాగనే "మ" అనే అక్షరం ఉచ్ఛరించినప్పుడు మననోరు మూసుకుంటుంది కనుక బయట మనకు కనిపించే ఆ పాపాలు ఏవీ మనలోకి ప్రవేశించలేవట. అందువల్లనే మానవులకు "రామ నామ స్మరణ" మిక్కిలి జ్ఞానాన్ని, జన్మ రాహిత్యాన్ని కలిగిస్తుందట. శ్రీరామనవమి రోజున వీధులలో పెద్ద పెద్ద పందిళ్ళు వేసి, సీతారామ కళ్యాణం చేస్తారు. ఇళ్ళల్లో కూడా యధా శక్తిగా రాముని పూజించి వడపప్పు, పానకం, నైవేద్యం చేసి అందరకీ పంచుతారు.',
        },
        {
          "title": '',
        },
        {
          "title": 'హిందూ సాంప్రదాయం ప్రకారం ప్రతి పండుగ కోక ప్రసాదం ఉంటుంది. భగవంతుడికి నైవేద్యంగా సమర్పించిన అనంతరం దానిని మనం ప్రసాదంగా స్వీకరిస్తాం. ఋతువుని బట్టీ దేవునికి సమర్పించే నైవేద్యం మారుతుంటుంది. ఉగాదితో వేసవి ఆరంభమవుతుంది. ఉగాదికి షడ్రుచుల పచ్చడిని ఎలా అయితే స్వీకరిస్తామో, శ్రీరామనవమి రోజున రాముల వారి కల్యాణం అనంతరం భక్తులకు వడపప్పు, పానకాన్ని ప్రసాదంగా పంచిపెడతారు. ఉగాది నుంచి ఎండ తీవ్రత పెరుగుతుంది. అందుకే శ్రీరామనవమికి తాటాకు పందిళ్లు వేస్తారు. అయితే పానకాన్ని పంచడం వెనుక ఒక ఆరోగ్య రహస్యం ఉంది. పానకం తాగడం వల్ల శరీరానికి చలువ చేస్తుంది. పానకంలో వేసే బెల్లం శరీరంలో వేడిని తగ్గిస్తుంది. అందులోనే ఐరన్ కూడా ఉంటుంది. అలాగే మిరియాలు కఫాన్ని తగ్గిస్తాయి. శొంఠి వల్ల దగ్గు రాకుండా ఉంటుంది. శరీరంలో ఉష్ణ శాతాన్ని సమంగా ఉంచుతుంది.',
        },
        {
          "title": '',
        },
        {
          "title": 'యాలుకలు సుగంధ ద్రవ్యాల్లో ఒకటి. ఇది జీర్ణప్రక్రియను సరిచేస్తుంది. తులసీదళం శ్రీ రామ చంద్రుల వారికి ప్రీతి పాత్రమైనది. రామనవమి రోజున రాముల వారిని ముఖ్యంగా తులసీ దళంతోనే పూజిస్తారు. తులసి ఆరోగ్యానికి మేలు చేస్తుంది. అలాగే వడపప్పు వడదెబ్బ తగలకుండా కాపాడుతుంది. అలా అని ప్రతిరోజూ పానకాన్ని తాగరు. అందుకే వేసవి ఆరంభంలో రాముల వారి కల్యాణం జరిగిన సందర్భంగా ప్రజలందరికీ ఇలా పానకాన్ని పంచిపెడతారు.',
        },
        {
          "title": '',
        },
      ],
      "title": 'శ్రీరామనవమి',
    },
    "radhasaptami": {
      "CatID": [
        // {
        //   "title":
        //     '@రథసప్తమి',
        // },
        // {
        //   "title": '',
        // },
        {
          "title": 'రథసప్తమి పర్వదినము రోజున ప్రాతః కాలమున అనగా సూర్యోదయానికి ముందే నిద్రలేచి ఇంటిని శుభ్రపరచుకొని, స్నానాదికాలు చేసి ఉతికిన వస్త్రాలు ధరించి, మామిడి తోరణములతో ఇంటిని అలంకరించాలి. ఆ తర్వాత దైవానికి పుష్పార్చన,అర్ఘ్యం,ధూప దీపాదులను సమర్పించి ఆవుపాలతో పొంగలి చేసి, చిక్కుడు ఆకులపై ఆ పొంగలిని ఉంచి సూర్య భగవానునికి నివేదన ఇవ్వాలి.',
        },
        {
          "title": '',
        },
        {
          "title": 'లోక సాక్షి ఐన ఆసూర్యభగవానుని అర్చించి ఆయన కరుణా కటాక్షాలను పొందే సప్తమే మాఘ శుద్ధ సప్తమి. అదే సూర్య భగవానుని జన్మతిధి "రథసప్తమి".',
        },
        {
          "title": '',
        },
        {
          "title": 'ఇతర మాసములలోని సప్తమి తిథులకన్న మాఘమాసమందలి సప్తమి బాగా విశిష్టమైనది. సూర్యుని గమనం ఏడు గుర్రముల బంగారు రథం మీద సాగుతుందని వేదము. సూర్య గమనం ప్రకారం ఉత్తరాయనము, దక్షిణాయనము అని రెండు విధములు. ఆషాఢమాసము నుండి పుష్యమాసము వరకు దక్షిణాయనము. సూర్యరథం దక్షిణాయనంలో దక్షిణ దిశగా పయనిస్తుంది. తరువాత సూర్యుడు మకరరాశి ప్రవేశం ఉత్తరాయన ప్రారంభ సూచకము "రథసప్తమి" అని పేరు వచ్చింది. అందుకే ఈరోజు పవిత్రదినముగా భావించి భారతీయులు సూర్యుని ఆరాధిస్తారు. "భా" అంటే సూర్యకాంతి, "రతి" అంటే సూర్యుడు, కావున సూర్యుని ఆరాధించువారు అందరూ భారతీయులు. "భారతీ" అంటే వేదమాత. వేదమాత నారాధించువారును భారతీయులే.',
        },
        {
          "title": '',
        },
        {
          "title": 'మాఘ శుద్ధ సప్తమి సూర్య గ్రహణముతో సమానము. ఆరోజు అరుణోదయవేళ స్నాన, జప, అర్ఘ్యప్రదాన, తర్పణ, దానాదులన్ని అనేక కోట్ల పుణ్య ఫలములను ఆయురారోగ్య సంపదలనిచ్చును. సప్తమి నాడు షష్ఠి తిథి గూడయున్నచో షష్టీ, సప్తమీ తిథుల యోగమునకు పద్మమని పేరు. ఈ యోగము సూర్యుని కత్యంత ప్రీతికరము. ఆ సమయమున ఏడు జిల్లేడు ఆకులను ధరించి నదీస్నానము చేసినచో ఏడు జన్మములలో చేసిన పాపములు నశిస్తాయని గర్గమహాముని ప్రబోధము. జిల్లేడు ఆకునకు అర్కపత్రమని పేరు. సూర్యునికి "అర్కః" అని పేరు. అందువలన సూర్యునికి జిల్లేడు అంటే ప్రీతి. ఏడు జిల్లేడు ఆకులు సప్తాశ్వములకు చిహ్నం మాత్రమే గాక, ఏడు జన్మల్లో చేసిన పాపములను, ఏడు రకములైన వ్యాధులను నశింపజేస్తాయి. ఈ జన్మలోను, జన్మాంతరంలోను (రెండు), మానసిక, వాచిక, శారీరకములు (మూడు), తెలిసిచేసేవి, తెలియకచేసేవి (రెండు) కలిసి మొత్తం ఏడు పాపములు నేడు రోగాలకు కారణములు.',
        },
        {
          "title": '',
        },
        {
          "title": 'రథసప్తమి నాడు బంగారము గాని, వెండి గాని, రాగి గాని రథమును చేయించి, కుంకుమాదులు, దీపములతో నలంకరించి అందు ఎర్రని రంగు గల సూర్యుని ప్రతిమ నుంచి, పూజించి, గురువునకు ఆ రథమును దానమీయవలెనని, ఆ రోజు ఉపవాసముండి, సూర్యసంబంధమగు రథోత్సవాది కార్యక్రమములను చూచుచూ కాలక్షేపం చేయాలి. ఇట్లు రథసప్తమీ వ్రతముచే సూర్యభగవానుని అనుగ్రహముచే ఆయురారోగ్యాది సకల సంపదలు కురియునని పురాణప్రబోధము. రథసప్తమి వ్రతము మన సంప్రదాయమున నిలచియుండుత భారతీయతకు చిహ్నము.',
        },
        {
          "title": '',
        },
        {
          "title": '@సూర్య జయంతి :',
        },
        {
          "title": '',
        },
        {
          "title": 'ఆదిత్యార్చన అద్భుత శక్తి. పవిత్ర మాఘమాసం మహిమాన్వితం. ఈ మాసంలో అన్ని శుభ దినాలే. మాఘమాసంలో చేసే స్నానం, దేవతార్చన అనంత పుణ్యఫలాలు ఇస్తుందని భక్తుల విశ్వాసం. ఏటా మాఘశుద్ధ సప్తమి రోజున రథసప్తమిగా, సూర్యజయంతిగా అత్యంత వైభవంగా జరుపుకుంటారు. రథసప్తమి రోజున సూర్యనారాయణస్వామి నిజరూపాన్ని దర్శించుకోవడం భక్తులు మరపురాని మధురానిభూతిగా భావిస్తారు. రథసప్తమి రోజున అర్ధరాత్రి నుంచే అరసవల్లిలో భక్తుల సందడితో ఆదిత్యుని జయంత్యుత్సవాల సందడి కనిపిస్తుంది.',
        },
        {
          "title": '',
        },
        {
          "title": '@ఆరోగ్య ప్రదాత:',
        },
        {
          "title": '',
        },
        {
          "title": 'మాఘశుద్ధ సప్తమి రోజున అరసవల్లి సూర్యనారాయణస్వామిని దర్శించి, సేవించడం ద్వారా రోగ, శోక, దారిద్య్రాలు పోతాయని భక్తుల నమ్మకం. అందుకే రథసప్తమి రోజున భక్తులు స్వామివారి నిజ రూప దర్శనం, మహా క్షీరాభిషేకం సేవలో పాల్గొని తరిస్తారు. మాఘశుద్ధ సప్తమి వేకువ జామున ఆకాశంలో నక్షత్రాలు రథం ఆకారంలో ఏర్పడుతుంటాయని, ఉత్తరాయణంలో వచ్చే చర్మ, కుష్ఠి, బొల్లి వ్యాధుల నుంచి రక్షణ పొందాలంటే సూర్యారాధన చేయాలని పెద్దలు వివరించారు.',
        },
        {
          "title": '',
        },
        {
          "title": '@అరుణశిల అత్యద్భుతం :',
        },
        {
          "title": '',
        },
        {
          "title": 'ఆదిత్యాలయంలో రథసప్తమి రోజున శ్రీసూర్యనారాయణస్వామి నిజరూప దర్శనం భక్తులకు మరపురాని మధురానిభూతి కలిగిస్తుంది. అరుణశిల దర్శించినంత మాత్రానే అద్భుతశక్తి శరీరంలోకి ప్రవేశించిన భావన కలుగుతుంది. ఆదిత్యాలయంలోని అయిదున్నర అడుగుల అరుణశిలతో దేవశిల్పి విశ్వకర్మ స్వామి మూలవిరాట్‌ను చెక్కినట్లు పురాణాలు చెబుతున్నాయి. మూలవిరాట్‌ కిందన వైజయంతి సప్త అశ్వరథం ఉంటుంది. రథంపై గుర్రాలు తాళ్లు పట్టుకుని సూర్య రథసారథి అనూరుడు ఉంటారు. స్వామి పాదాల ముందర ఛాయాదేవి, స్వామి ఎడమవైపు, కుడివైపు ఉషా, పద్మినిదేవి ఉంటారు. ముగ్గురు దేవేరుల్లో ఉషా, పద్మిని ధనుస్సులు ధరించి ఉంటారు. స్వామికి ఎడమవైపున ద్వారపాలకుడైన మాఠరుడు కత్తి, డోలు ధరించి ఉంటాడు. స్వామికి కుడివైపున చిన్న గడ్డంతో కూడిన పింగళుడు ఎడమవైపు సిరాబుడ్డీ, కుడిచేతిలో కలం పట్టుకుని ఉంటాడు. ఈయనే భక్తులు చేసే విన్నపములను, కోరికలు స్వీకరించి స్వామికి నివేదిస్తారు. స్వామికి శిరస్సుకు ఎడమవైపు సనకుడు ఛత్రంలోను, కుడివైపున సనందుడు అనే మహర్షి ఛామరం పట్టుకుని సేవలు అందిస్తారు. స్వామికి రెండు చేతులు అభయ ముద్రలలో ఉంటాయి. స్వామి భుజాలకు ఇరువైపుల తామరపూలు, మొగ్గులను ధరించి ఉంటారు. సూర్యనారాయణ స్వామి మెడలో హారాలు, మకర కుండలాలు, కేయూరాలు, రత్నఖచిత సూర్యమణి కిరీటంతో చిరునవ్వుతో స్థానక భంగిమలో భక్తులకు స్వామి దర్శనం ఇస్తుంటారు. స్వామి శిరస్సు మీద శరభ సాల్వం అనే పతాక చిహ్నం ఉంటుంది.',
        },
        {
          "title": '',
        },
        {
          "title": '@పాయసాన్నం పరమౌషధం :',
        },
        {
          "title": 'రథసప్తమి రోజున ప్రాతః కాలమున కొత్తబెల్లం, కొత్తబియ్యం, ఆవుపాలతో పాయాసాన్నం చేసి స్వామికి నివేదించి ప్రసాధాన్ని స్వీకరించినట్లైతే నరాలు, కీళ్ల నొప్పులు, హృద్రోగ సంబంధ వ్యాధులు నశిస్తాయి. స్వామికి సమర్పించిన తీపి పదార్థంపై లేత సూర్యకిరణాలు పడడం వల్ల శరీరంలో రోగ నిరోధకశక్తి పెరిగి, మధుమేహవ్యాధిని తగ్గిస్తుంది. పాయాసన్నంలో వాడే చెరకు వల్ల పళ్లు, దవడలు, నరాలకు శక్తి వస్తుంది. రథసప్తమి రోజు నదులు, చెరువుల్లో దీపం వదిలివేస్తే మరుజన్మ ఉండదని భక్తుల విశ్వాసం. జిల్లేడు ఆకులు శిరస్సున, రెండు భుజాలపైన రేగుపళ్లు పెట్టుకుని స్నానం చేస్తే ఏడు జన్మల రోగాల పోయి, మనస్సు, నవరంధ్రాలు, పంచేంద్రియాలు సుషుప్తావస్థ నుంచి జాగృతావస్థలోకి వస్తాయని చెబుతారు. రథసప్తమి రోజున స్వామి నిజరూప దర్శనం వల్ల అభిషేకం చేసిన అరుణశిల కిరణాల స్పర్శతో భక్తులకు రోగ నివారణ కలుగుతుందని నమ్ముతారు.',
        },
        {
          "title": '',
        },
        {
          "title": '@వ్రతకథ :',
        },
        {
          "title": '',
        },
        {
          "title": '@రథసప్తమి వ్రత విధానాలు, విశేష వర్ణనలు :',
        },
        {
          "title": '',
        },
        {
          "title": 'ఈ వ్రత ఫలాన్ని గురించి అడిగిన ధర్మరాజునకు శ్రీకృష్ణుడు ఇలా తెలియజేసెను. పూర్వము కాంభోజ దేశమున యశోధర్ముడను రాజుండెను. అతనికి ఒక కుమారుడు కలిగెను. ఆ కుమారునికి ఎప్పుడును రోగములు వచ్చెడివి. తన కుమారునికి వ్యాధులకు కారణమేమని రాజు బ్రాహ్మణులను అడిగెను. "నీ కుమారుడు పూర్వ జన్మమున పరమలోభియైన వైశ్యుడు. రథసప్తమి మహత్మ్యము వలన నీ కడుపున పుట్టెను. లోభియగుట వలన వ్యాధిగ్రస్తుడయ్యెను అని తెలిపిరి. దీనికి పరిహారమడిగిన రాజుకు బ్రాహ్మణులు ఎలా చెప్పారు. ఏవ్రత ఫలితమున ఇతడు నీకు కలిగెనో అదే రథసప్తమి వ్రతమును ఆచరించిన పాపము నశించి చక్రవర్తిత్వము పొందును. ఆ వ్రత మాచరించిన రాజునకు తగిన ఫలితము కలిగెను.',
        },
        {
          "title": '',
        },
        {
          "title": 'రథసప్తమీ వ్రతకథ యధిష్ఠిరుడు కృష్ణుని అడిగెను."ఓ కృష్ణా! రధసప్తమినాడు చేయవలసిన విధివిధానము ననుసరించి, భూలోకమున మనుష్యుడు చక్రవర్తి కాగలడని నీవు చెప్పియుంటివి. అట్లు యెవ్వరికైననూ ప్రాప్తించినదా?" అని అడుగగా, కృష్ణుడిట్లు జవాబిచ్చెను.',
        },
        {
          "title": '',
        },
        {
          "title": 'కాంభోజదేశమున యశోవర్తియను చక్రవర్తి ఉండెను. ఆయన వృద్ధాప్యమున ఆయన కుమారులందరు సర్వరోగముల చేత బాధపడుచున్న వారైరి అట్టి కర్మపరిపాకముయెందు వలన గల్గెనోతెలుపవలసినదని ఒకానొక బ్రాహ్మణ శ్రేష్ఠుని అడిగెను. అట్లడిగిన రాజుతో "ఓరాజా! వీరు వీరి పూర్వజన్మలో వైశ్యకులమున జన్మించ మిక్కిలి లోభులైయుండిరి. అందుచేత వీరిట్టి రోవములకు గురికావలసిన వారైరి, వారి రోగనివారణకు రధసప్తమి రోజున జరుగు కార్యక్రమమును చూడవలెను. అ విధముగా నావ్రతము చూచినంత మాత్రమున దాని మహాత్యముచే వారి పాపములు పోవును. కాన వ్యాధితో బాధపడువారిని గొని వచ్చి ఆ వ్రతవైభవము వారికి చూపవలెను. అని బ్రాహ్మణుడు చెప్పగా, రాజు అయ్యా! ఆ వ్రతమెట్లు చేయవలెనో దాని విధివిధానమును తెలుపు" డని ప్రార్ధించెను.',
        },
        {
          "title": '',
        },
        {
          "title": 'అందులకా బ్రాహ్మణుడు ఓ రాజా! ఏ వ్రతము చూచినంత మాత్రమున జడత్వము నశించిపోవునో "రధసప్తమి" అని పేరుగల వ్రతము సర్వులూ ఆచరించదగినది. ఆ వ్రత ప్రభావమున సకల పాపములూ హరించి, చక్రవర్తిత్వము గల్గును. ఆ వ్రతవిధానమును తెలుపుచున్నాను శ్రద్ధగా వినుము.',
        },
        {
          "title": '',
        },
        {
          "title": 'మాఘమాసమందలి శుక్లపక్షమున వచ్చు షష్ఠి తిధి దినమున మీ గృహమున ఈ వ్రతమాచరింతునని తలంపవలెను. పవిత్ర జలము గల నదులలోగాని, చెరువునందు గాని, నూతియందుగాని తెల్లని నువ్వులతో విధివిధానముగా స్నానమాచరించవలెను. ఇలవేలుపులకు, కులదేవతలకు, ఇష్టదేవతలకు మ్రొక్కి, పూజించి అటుపిమ్మట సూర్యదేవాలయమునకు పోయి ఆయనకు నమస్కరించి పుష్పములు, ధూపములు, దీపమును అక్షితలతో శుభప్రాప్తికొరకు పూజించవలెను. పిదప స్వగృహమునకు వచ్చి పంచయజ్ఞము గావించి, అతిధులతో, సేవకులతో, బాలకులతో భక్ష్యభోజ్యములు ఆరగించవలెను. ఆదినమున తైలము శరీరమునకు పూసుకొని స్నానము చేయరాదు. ఆ రాత్రి వేదపారంగులగు విప్రులను పిలిపించి, సూర్యభగవానుని విగ్రహానికి నియమము ప్రకారము పూజించి, సప్తమి తిధి రోజున నిరాహారుడై, భోగములను విసర్జించవలెను. భోజనాలకు పూర్వము "ఓ జగన్నాధుడా! నేను చేయబోవు ఈ రథసప్తమీ వ్రతమును నిర్విఘ్నముగా పరిసమాప్తి చేయవలసిందిగా వేడుచున్నాను" అని ఉచ్చరించుచు, తన చేతిలో గల జలమును నీటిలో విడవవలెను. అట్లు నీటిని విడిచిపెట్టి బ్రాహ్మణులు, తాను, గృహమున నేలపైనా శయనించి జితేంద్రియుడై ఉండి, ఉదయమున లేచి నిత్యకృత్యములాచరించి శుచియై ఉండవవలెను. ఒక దివ్యమైన సూర్యర్ధాన్ని దివ్యమాలికలతోను, చిరుగంటలతోను, సర్వోపచారాలతోను తయారు చేసి సర్వాంగములును రత్నాలు, మణులుతో అలంకరించవలెను. బంగారముతోగాని, వెండితోగాని, గుర్రాలను, రధసారధినీ, రధమునూ తయారు చేసి మధ్యాహ్నవేళ స్నానాదికములను నిర్విర్తించుకొనవలెను. వదరబోతులను, పాషండులను, దుష్టులను విడిచిపెట్టి ప్రాజ్ఞులు, సౌరసూక్తపారాయణ చేయుచుండగా నిజగృహము చేరవలెను.',
        },
        {
          "title": '',
        },
        {
          "title": 'పిమ్మట తననిత్యకృత్యములను పూర్తి చేసుకొని స్వస్తి బ్రాహ్మణ వాచకములతో వస్త్రమండప మధ్యభాగమున రధమును స్థాపించవలెను. కుంకుమతోను, సుగంధద్రవ్యములతోను, పుష్పములతోను పూజించి రధమును పుష్పములతోను, దీపములతోను అలంకరించవలెను. అగరుధూపములుంచవలెను. రధమధ్యముననున్న సూర్యుని సర్వ సంపూర్ణముగా అర్చన చేయవలెను. ధనలోభము చేయరాదు. లోభియై ధనమును ఖర్చు చేయుటకు మనస్సంగీకరించనిచో వ్రతము వైఫల్యమును, దానివలన మనస్సు నికలత్వమును పొందును. పిమ్మట రధాన్నీ, రధసారధిని అందుగల సూర్యభగవానునీ పుష్ప, ధూప, గంధ, వస్త్రాలు అలంకారాలు భూషణాలు నానావిధ పంచభక్ష్యాదులు గల నైవేద్యాదులతో పూజించి ఈ క్రింది విధముగా దివాకరుని స్తోత్రము చేయవలెను.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఓ భాస్కరా! దివాకరా! ఆదిత్యా! మార్తాండా! గ్రహాధిపా అపారనిధే! జగద్రక్షకా! భూతభవనా! భూతేశా! భాస్కరా! ఆర్తత్రాణ పరాయణా హరా! అంచిత్యా విశ్వసంచారా! హేవిష్ణో! ఆదిభూతేశా! ఆదిమధ్యాస్త భాస్కరా! ఓ జగత్ప్రతే! భక్తి లేకున్నను, క్రియాశూన్యమయినను, నేను చేసిన అర్చనకు నీ సంపూర్ణ కటాక్షమును చూపుము". పై విధముగా మనస్సులో తాను వేడిన కోరికను సఫలీకృతం చేయవలెనని భాస్కరుని ప్రార్దించవలెను. ధనహీనుడయినను, విధిప్రకారము అన్ని కార్యములు చేయవలెను. రధము, సారధి, గుర్రములు వివిధరకాల రంగులతో లిఖించిన బొమ్మలు, జిల్లేడుప్రతిమలతో సూర్యభగవానుని శక్తి కొలది పూర్వము చెప్పినట్లు విధివిధానముగా పూజించవలెను. ఆ రాత్రి జాగరణ చేసి, పురాణ శ్రావణ మంగళగీతాలతో మంగళవాయుధ్యాలతో పుణ్యకధలను వినవలెను. పిమ్మట రధయాత్రకు బయలుదేరి సూర్యున్ని మనస్సున ధ్యానమణేయుచు అర్ధనిమీలిత నేత్రుడై చూడవలెను. ప్రాతఃకాలమున లేచి విమలుడై స్నానకృత్యము నిర్వర్తించుకొని బ్రాహ్మణులకు తృప్తిగా భోజనము పెట్టి, వివిధ రత్నభూషణములతో ధాన్యాదులతో, వస్త్రాలతో తృప్తిపరచవలెను. అట్లు చేసిన అశ్వమేధయాగము చేసిన ఫలము లభించును అని బ్రహ్మవిధులు చెప్పిరి. పిమ్మట యధాశక్తి దానము నీయవలెను. ఈ రధమును తమ పురోహితులయిన గురుదేవులకు రక్తవస్త్ర యుగళంతో సమర్పించవలెను. ఆవిధంగా చేసినచో ఎందుకు జగత్పతిగాకుండును? కాన సర్వయత్నముల చేత రధసప్తమి వ్రతమాచరించవలెను, దానివలన భాస్కరానుగ్రహము గల్గి మహాతేజులు, బలపరాక్రమవంతులు అయి విపుల భోగములననుభవించి రాజ్యమును నిష్కంటకముగా చేసికొందురు. ఈ రధసప్తమి వ్రతమును చేసినచో పుత్రపౌత్రాదులను బడసి చివరగా సూర్యలోకము చేరును, అక్కడ ఒక కల్పకాలము చక్రవర్తి పదవి ననుభవించును".',
        },
        {
          "title": '',
        },
        {
          "title": 'ఈ విధంగా ఆ ద్విజోత్తముడు సర్వవిషయములను చెప్పి తన దారిని తాను పోయెను. రాజు ఆ బ్రాహ్మణ శ్రేష్ఠుడుపదేశించినరీతిగా ఆచరించి సమస్తసౌఖ్యముల అనుభవించెను. ఈ విధముగా ఆ రాజపుత్రులు చక్రవర్తిత్వమును పొందిరి. ఈ కధను భక్తితో ఎవరు విందురో వారికి భానుడు సంతసించి మంచి ధనధాన్య సంపదనిచ్చును. ఈ విధముగా బంగారముతో చేయబడిన సారధి గుర్రాలతో గూడుకొనిన శ్రేష్ఠరధమును మాఘమాస సప్తమిరోజున ఎవరు దానము చేయుదురో వారు చక్రవర్తిత్వమును పొందగలరు.',
        },
        {
          "title": '',
        },
      ],
      "title": 'రథసప్తమి',
    },
    "deepavali": {
      "CatID": [
        {
          "title":
            'దీపావళి',
        },
        {
          "title": '',
        },
        {
          "title": 'దీపావళి అనగా దీపాల శ్రేణి (లేదా) దీపాల వరుస. భారతీయ సంస్కృతికి ప్రతిబింబంగా వెలుగొందేవి భారతీయ పండుగలు. వాటిలో ఆనంద ఉత్సాహాలతో జాతి, కుల, మత, వర్గ విభేదాలను విస్మరించి సమైక్యంగా జరుపుకునే పండుగే దివ్య దీప్తుల దీపావళి. జగతిని జాగృతం చేసే చైతన్య దీప్తుల శోభావళి. నరకాసురుడనే రాక్షసుడిని సంహరించిన మరుసటి రోజు అతడి పీడ వదిలిన ఆనందంలో ప్రజలు దీపావళి పండుగను చేసుకుంటారని పురాణాలు చెబుతున్నాయి.',
        },
        {
          "title": '',
        },
        {
          "title": 'అలాగే లంకలోని రావణుడిని సంహరించి శ్రీరాముడు సతీసమేతంగా అయోధ్యకు తిరిగి వచ్చినపుడు కూడా ప్రజలు ఆనందోత్సవాల మధ్య దీపావళిని జరుపుకున్నారని రామాయణం చెపుతోంది. చీకటిని పారద్రోలుతూ వెలుగులు తెచ్చే పండుగగా, విజయానికి ప్రతీకగా దీపావళి పండుగను జరుపుకుంటారు.',
        },
        {
          "title": '',
        },
        {
          "title": 'దీప మాళికల శోభతో వెలుగొందే గృహాంగణాలు, ఆనంద కోలాహలంతో వెల్లివిరిసే ఆబాల గోపాలం, నూతన వస్త్రాల రెపరెపలు, పిండివంటల ఘుమఘుమలు, బాణసంచా చప్పుళ్ళు, ఈ దివ్య దీపావళి సోయగాలు. ఈ పండుగ ప్రతియేటా ఆశ్వీయుజ అమావాస్య రోజున వస్తుంది. దీపాల పండుగకు ముందు రోజు ఆశ్వయుజ బహుళ చతుర్థశి. దీన్ని నరక చతుర్థశిగా జరుపుకుంటారు.',
        },
        {
          "title": '',
        },
        {
          "title": '@దీపాలంకరణ, లక్ష్మీ పూజ :',
        },
        {
          "title": '',
        },
        {
          "title": 'శ్లో|| దీపం జ్యోతిః పరంబ్రహ్మ దీపం సర్వతమోపహమ్ |',
        },
        {
          "title": 'దీపేన సాధ్యతే సర్వమ్ సంధ్యా దీప నమోஉస్తుతే ||',
        },
        {
          "title": '',
        },
        {
          "title": 'దీపజ్యోతిని పరబ్రహ్మ స్వరూపంగా, మనోవికాసానికి, ఆనందానికి, నవ్వులకు, సజ్జనత్వానికి, సద్గుణ సంపత్తికి నిదర్శనంగా భావిస్తారు. మహిళామణులంతా ఆశ్వీయుజ బహుళ చతుర్దశి నుండి కార్తీక మాసమంతా సంధ్యా సమయంలో మట్టి ప్రమిదలలో దీపాలను వెలిగిస్తారు. చివరకు ఈ దీపాలను ముత్తయిదువులు కార్తీక పౌర్ణమికి సముద్ర స్నానాలను ఆచరించి జీవనదులలో వదులుతారు. ఇవి సౌభాగ్యానికి, సౌశీల్యానికి, సౌజన్యానికి ప్రతీకలుగా భావిస్తారు. పైగా ఈ దీపావళి శరదృతువులో అరుదెంచటం విశేషం. మనోనిశ్చలతకు, సుఖశాంతులకు అనువైన కాలమిది.',
        },
        {
          "title": '',
        },
        {
          "title": 'దీపాలపండుగ అయిన దీపావళి రోజున మహాలక్ష్మీ పూజను జరుపుకోవడానికి ఓ విశిష్టత ఉంది. పూర్వం దుర్వాస మహర్షి ఒకమారు దేవేంద్రుని ఆతిథ్యానికి సంతసించి, ఒక మహిమాన్వితమైన హారాన్ని ప్రసాదించాడు. ఇంద్రుడు దానిని తిరస్కార భావముతో తన వద్దనున్న ఐరావతం అను ఏనుగు మెడలో వెేస్తాడు. అది ఆ హారాన్ని కాలితో తొక్కివేస్తుంది. అది చూచిన దుర్వాసనుడు ఆగ్రహము చెంది దేవేంద్రుని శపిస్తాడు. తత్ఫలితంగా దేవేంద్రుడు రాజ్యమును కోల్పోయి, సర్వసంపదలు పోగొట్టుకుని దిక్కుతోచక శ్రీహరిని ప్రార్థిస్తాడు. ఈ పరిస్థితిని గమనించిన శ్రీ మహావిష్ణువు దేవేంద్రుని ఒక జ్యోతిని వెలిగించి దానిని శ్రీ మహాలక్ష్మీ స్వరూపంగా తలచి పూజించమని సూచిస్తాడు. దానికి తృప్తిచెందిన లక్ష్మీదేవి అనుగ్రహంతో తిరిగి త్రిలోకాధిపత్యాన్ని, సర్వసంపదలను పొందాడని పురాణాలు చెబుతున్నాయి.',
        },
        {
          "title": '',
        },
        {
          "title": 'ఆ సమయంలో శ్రీ మహావిష్ణువు చెంతనే ఉండే మహాలక్ష్మీదేవిని ఇంద్రుడు ఇలా ప్రశ్నించాడు. తల్లి నీవు కేవలం శ్రీహరి వద్దనే ఉండటం న్యాయమా? నీ భక్తులను కరుణించవా? అంటాడు. దీనికి ఆ మాత సమాధానమిస్తూ, త్రిలోకాథిపతీ "నన్ను త్రికరణ శుద్ధిగా ఆరాధించే భక్తులకు వారి వారి అభీష్టాలకు అనుగుణంగా మహర్షులకు మోక్షలక్ష్మీ రూపంగా, విజయాన్ని కోరేవారికి విజయలక్ష్మీగా, విద్యార్థులు నన్ను ఆరాధిస్తే విద్యాలక్ష్మీగా, ఐశ్వర్యాన్ని కోరి ఆరాధించే వారికి ధనలక్ష్మీగా, వారి సమస్త కోరికలు నెరవేర్చే వరలక్ష్మీ దేవిగా ప్రసన్నురాలౌతానని" సమాధానమిచ్చింది. అందుచేత దీపావళి రోజున మహాలక్ష్మిని పూజించేవారికి సర్వసంపదలు చేకూరుతాయని విశ్వాసం.',
        },
        {
          "title": '',
        },
        {
          "title": '@నరక చతుర్దశి :',
        },
        {
          "title": '',
        },
        {
          "title": 'ఆశ్వీయుజ బహుళ చతుర్దశి "నరక చతుర్దశి" గా ప్రసిద్ధి పొందింది. నరకాసురుడు అనే రాక్షసుడు చెలరేగి సాధు జనాలను పీడిస్తూ దేవ, మర్త్య లోకాలలో సంక్షోభాన్ని కలిగిస్తుంటాడు. కృతయుగంలో హిరణ్యాక్షుని వధించిన వరాహస్వామికి, భూదేవికి అసుర సంధ్యా సమయంలో జన్మిస్తాడు నరకుడు. అతడు లోక కంటకుడైనా మహావిష్ణువు వధించరాదని, తల్లియైన తన చేతిలోనే మరణించేలా వరం పొందుతుంది భూదేవి. మహావిష్ణువు ద్వాపరయుగంలో శ్రీకృష్ణ భగవానునిగా అవతరించినప్పుడు భూదేవి సత్యభామగా జన్మిస్తుంది.',
        },
        {
          "title": '',
        },
        {
          "title": 'అప్పటికి నరకాసురుడు లోక కంటకుడై చేస్తున్న అధర్మకృత్యాలను అరికట్టడానికి సత్యభామా సమేతంగా తరలి వెళ్తాడు శ్రీకృష్ణుడు. వారి మధ్యజరిగిన భీకర సంగ్రామంలో భూదేవి అంశ అయిన సత్యభామ శరాఘాతాలకు మరణిస్తాడు నరకుడు. తన పుత్రుని పేరైనా కలకాలం నిలిచి ఉండేలా చేయమని సత్యభామ ప్రార్థించడంతో ఆ రోజు "నరక చతుర్థశి" గా పిలువబడుతుందని వరం ప్రసాదిస్తాడు శ్రీకృష్ణుడు. నరకుని చెరనుండి సాధుజనులు, పదహారువేలమంది రాజకన్యలు విడిపించబడ్డారు, ధర్మం సుప్రతిష్ఠమైంది.',
        },
        {
          "title": '',
        },
        {
          "title": 'నరకాసురుని పీడ విరగడైందన్న సంతోషంతో ఆ మరుసటి రోజు ప్రజలు సంబరాలు జరుపుకుంటారు. ఈ సంబరాలు జరుపుకునే రోజు అమవాస్య కావడంతో, చీకటిని పారద్రోలుతూ ప్రజల దీపాలతో తోరణాలు వెలిగించి, బాణాసంచా కాల్చి వేడుక చేసుకున్నారు. కాలక్రమంలో అదే దీపావళి పర్వదినంగా మారింది.',
        },
        {
          "title": '',
        },
        {
          "title": '@భగినీ హస్త భోజనం :',
        },
        {
          "title": '',
        },
        {
          "title": 'దీపావళి కొన్ని ప్రాంతాల్లో అయిదు రోజుల పండుగగా జరుపుకుంటారు. ఆశ్యయుజ బహుళ త్రయోదశితో ప్రారంభమైన దీపావళి వేడుకలు, కార్తీక శుద్ద విదియ భగినీహస్త భోజనంతో ముగుస్తాయి.ఈ భగినీ హస్త భోజనం సోదరుని క్షేమానికి సంబంధించినది.దీపావళి అయిన రెండో రోజు చేసుకుంటారు. ఈ రోజును పుష్ప ద్వితీయ, యమ ద్వితీయ, కాంతి ద్వితీయ, వంటి అనేక పేర్లతో పిలుస్తారు.',
        },
        {
          "title": '',
        },
        {
          "title": '@బాణాసంచా చరిత్ర :',
        },
        {
          "title": '',
        },
        {
          "title": 'సూరేకారంగా జనసామాన్యం పిలిచే పొటాషియం నైట్రెట్ ను కనుగొన్న తర్వాత దీపావళి జరుపుకొనే తీరు మారింది. క్రీస్తు శకం 960-1279 కాలం లోని సాంగ్ వంశీయుల హయాంలో చైనీయులు సూరేకారం, గంధకం పొడి, బొగ్గు పొడి కలిపి గన్ పౌడర్ ను తయారు చేసారు. మంట అంటుకోగానే భారీ శబ్దంతో పేలే గన్ పౌడర్ ఆవిష్కరణ తో చరిత్ర గతిలో మార్పులు శరవేగాన్ని పుంజుకున్నాయి. క్రీస్తుశకం 14 వ శతాబ్దము నాటికి భారత భూభాగంలో గన్ పౌడర్ ను యుద్ధాలలో వాడడం మొదలైంది. ఫిరంగుల్లో మందుగుండును దట్టించి పేల్చి శత్రువులను తరిమి కొట్టడం, దుర్భేధ్యమైన కోటలను ఫిరంగి గుళ్ళ దాడితో పడగొట్టడం మొదలైంది.',
        },
        {
          "title": '',
        },
        {
          "title": 'వివిధ ప్రయోగాల ద్వారా రకరకాల బాణాసంచా తయారీ ప్రారంభమైంది. సురేకారం,గంధకం,బొగ్గుపొడి రకరకాల పాళ్ళలో కలిపి తక్కువ పేలుడు కలిగించేవి, రంగులు విరజిమ్మేవి మొదలైనవి ప్రారంభమైనవి.ఇవన్నీ చైనాలో దాదాపు క్రీస్తు శకం 12 వ శతాబ్ది నాటికే ప్రారంభమైనా, భారతదేశంలో మాత్రం 14 వ శతాబ్ది నుండే ప్రారంభమైనట్లు చారిత్రక ఆధారాలను బట్టి తెలుస్తుంది.',
        },
        {
          "title": '',
        },
      ],
      "title": 'దీపావళి',
    },
  }
  // export default festivaldetailsData;